/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Goal domain used for persistence and query filtering */
export enum GoalDomainEnum {
  FINANCE = "FINANCE",
  INVEST = "INVEST",
  OTHER = "OTHER",
}

/**
 * Member product capability domain.
 * Universal products include both INVEST and PLAN.
 */
export enum MemberProductDomainEnum {
  INVEST = "INVEST",
  PLAN = "PLAN",
}

/** member product level */
export enum MemberProductLevelEnum {
  EXPERT = "EXPERT",
  PRO = "PRO",
  FREE = "FREE",
}

/** Equity grant code enum */
export enum EquityGrantCodeEnum {
  MEMBER_CANCEL_SUBSCRIPTION_RETENTION_CREDIT = "MEMBER_CANCEL_SUBSCRIPTION_RETENTION_CREDIT",
}

/** 兑换类型枚举 */
export enum RedeemTypeEnum {
  MEMBER = "MEMBER",
  AURA = "AURA",
}

/** membership status */
export enum MemberStatusEnum {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
}

export enum SecurityVerifyScene {
  LOGIN = "LOGIN",
  REGISTER = "REGISTER",
  VERIFY = "VERIFY",
  SUBSIDY_GAS = "SUBSIDY_GAS",
  CLAIM_BADGE = "CLAIM_BADGE",
  AURA_AWARD = "AURA_AWARD",
  AURA_SCORE = "AURA_SCORE",
  AI_SEARCH = "AI_SEARCH",
  ALL = "ALL",
  UNKNOWN = "UNKNOWN",
}

/** Denormalized schedule frequency on Tracker for calendar OTS recall and display. */
export enum ScheduleFreqEnum {
  Once = "once",
  Minutely = "minutely",
  Hourly = "hourly",
  Daily = "daily",
  Weekly = "weekly",
  Monthly = "monthly",
  Custom = "custom",
}

/** Who executes the schedule tracker action. */
export enum TrackerActorEnum {
  USER = "USER",
  AI = "AI",
  SYSTEM = "SYSTEM",
}

/** Tracker business domain for calendar styling and filtering. */
export enum TrackerDomainEnum {
  Finance = "finance",
  Invest = "invest",
}

/** Goal domain used for persistence and query filtering */
export enum DomainEnum {
  FINANCE = "FINANCE",
  INVEST = "INVEST",
  OTHER = "OTHER",
}

/**
 * Ad attribution channel for Brief recommend feed.
 * Present = ad-attribution session; omit with query_source empty = organic.
 * THEME_RANK = theme-rank landing session; landing_id carries the OpenData theme slug.
 * SAVING_ONBOARDING_SKIP = saving-ad landing session that also skips onboarding (reuses the saving ad-landing pool).
 * AI_JOB_RISK = "AI is coming for your job" ad landing session; walks the full 9-question onboarding (it does NOT skip onboarding).
 * @example "ALPHA_PICK"
 */
export enum BriefQueryChannelEnum {
  ALPHA_PICK = "ALPHA_PICK",
  PORTFOLIO_CHECK = "PORTFOLIO_CHECK",
  SAVING = "SAVING",
  SAVING_ONBOARDING_SKIP = "SAVING_ONBOARDING_SKIP",
  THEME_RANK = "THEME_RANK",
  AI_JOB_RISK = "AI_JOB_RISK",
}

/**
 * Brief feed query type; omit for legacy trackerId dispatch
 * @example "RECOMMEND"
 */
export enum BriefQueryTypeEnum {
  RECOMMEND = "RECOMMEND",
}

/**
 * Expected direction when comparing current_value against target_value for one metric item.
 * - UP: higher current_value means better progress (e.g. savings, portfolio value).
 * - DOWN: lower current_value means better progress (e.g. debt reduction).
 */
export enum GoalTargetDirectionEnum {
  UP = "UP",
  DOWN = "DOWN",
}

/**
 * listGoals sort mode (V2.8).
 * - CREATED: order by goal created time descending (newest first); default.
 * - PRIORITY: order by checkup dimension Engine priority (GoalDimension.sort ascending, 1 = highest).
 * @default "CREATED"
 */
export enum GoalSortEnum {
  CREATED = "CREATED",
  PRIORITY = "PRIORITY",
}

/**
 * Goal progress bar rendering type; paired with value_unit on tracker_goal.
 * - PROGRESS_BAR: absolute value bar (current/target with numeric scale).
 * - PROGRESS_RATE: percentage / completion rate bar.
 */
export enum ProgressTypeEnum {
  PROGRESS_BAR = "PROGRESS_BAR",
  PROGRESS_RATE = "PROGRESS_RATE",
}

/** Financial planning domain ring category. Persisted as int code 1-4 on tracker_goal.category. */
export enum GoalCategoryEnum {
  FINANCIAL_SECURITY = "FINANCIAL_SECURITY",
  CASH_OPTIMIZATION = "CASH_OPTIMIZATION",
  WEALTH_BUILDING = "WEALTH_BUILDING",
  LIFE_DECISIONS = "LIFE_DECISIONS",
}

/** Tracker lifecycle status. This is intentionally distinct from GoalStatusEnum. */
export enum TrackerStatusEnum {
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
  COMPLETE = "COMPLETE",
  STOP = "STOP",
  DELETE = "DELETE",
}

/**
 * Goal lifecycle status stored on tracker_goal.status (V2.8).
 * - INACTIVE: checkup done, pending activation (default on createGoal).
 * - PLANNED: plan saved, pending paywall + activate (V3.0.1).
 * - ACTIVE: in progress.
 * - COMPLETED: finished successfully.
 * - DELETED: soft-deleted by user; cascades tracker DELETE.
 */
export enum GoalStatusEnum {
  INACTIVE = "INACTIVE",
  PLANNED = "PLANNED",
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  DELETED = "DELETED",
}

/** badge check status enum */
export enum ClaimableBadgeSortEnum {
  LEVEL_DESC = "LEVEL_DESC",
  LEVEL_ASC = "LEVEL_ASC",
}

/** badge check status enum */
export enum CheckStatus {
  CHECKING = "CHECKING",
  CHECKED = "CHECKED",
  PENDING_CHECK = "PENDING_CHECK",
}

/** badge check status enum */
export enum BadgeStatus {
  PENDING = "PENDING",
  CLAIMABLE = "CLAIMABLE",
  CLAIMED = "CLAIMED",
  FAILED = "FAILED",
}

/** chain name */
export enum ChainNameEnum {
  BASE = "BASE",
  ETHEREUM = "ETHEREUM",
  SOLANA = "SOLANA",
}

/**
 * business type
 * @default "OWNER"
 */
export enum BusinessTypeEnum {
  OWNER = "OWNER",
  DAPP = "DAPP",
  OSP_TO_PLATFORM = "OSP_TO_PLATFORM",
}

/** type */
export enum BindLinkTypeEnum {
  BIND_TELEGRAM = "BIND_TELEGRAM",
  JOIN_TELEGRAM_GROUP = "JOIN_TELEGRAM_GROUP",
  JOIN_DISCORD_GROUP = "JOIN_DISCORD_GROUP",
  BIND_TWITTER = "BIND_TWITTER",
  BIND_DISCORD = "BIND_DISCORD",
  BIND_YOUTUBE = "BIND_YOUTUBE",
}

/** type */
export enum BindTypeEnum {
  DISCORD = "DISCORD",
  TWITTER = "TWITTER",
  YOUTUBE = "YOUTUBE",
  TELEGRAM = "TELEGRAM",
  WALLET = "WALLET",
  TIKTOK = "TIKTOK",
  INSTAGRAM = "INSTAGRAM",
}

/** reaction kind */
export enum PopularityEnum {
  FOLLOWER = "FOLLOWER",
  MEMBER = "MEMBER",
}

/** Identity type enum (EMAIL/X_ID/EOA_ADDRESS/OWNER_ID/X_HANDLE) */
export enum IdentityTypeEnum {
  EMAIL = "EMAIL",
  X_ID = "X_ID",
  X_HANDLE = "X_HANDLE",
  EOA_ADDRESS = "EOA_ADDRESS",
  OWNER_ID = "OWNER_ID",
}

/** badge strategy */
export enum StrategyEnum {
  Any = "any",
  All = "all",
  Max = "max",
  Sum = "sum",
}

/** condition operator */
export enum OperatorEnum {
  LT = "LT",
  LTE = "LTE",
  EQ = "EQ",
  GTE = "GTE",
  GT = "GT",
}

/** condition type */
export enum ConditionTypeEnum {
  NATIVE = "NATIVE",
  ERC20 = "ERC20",
}

/** condition calculate type */
export enum CalculateTypeEnum {
  COUNT = "COUNT",
  SCORE = "SCORE",
}

/** feedback action type */
export enum FeedbackActionEnum {
  UPVOTE = "UPVOTE",
  DOWNVOTE = "DOWNVOTE",
}

/** feed source */
export enum AIFeedSourceEnum {
  OSP = "OSP",
  TWITTER = "TWITTER",
  YOUTUBE = "YOUTUBE",
}

/** activity status */
export enum SearchTypeEnum {
  POST = "POST",
  TOPIC = "TOPIC",
  USER = "USER",
  STORY = "STORY",
  MEDIA = "MEDIA",
  EVENT = "EVENT",
  COMMUNITY = "COMMUNITY",
  HASHTAG = "HASHTAG",
  POST_HASHTAG = "POST_HASHTAG",
  OPEN_DATA = "OPEN_DATA",
}

/** app data status */
export enum AppDataStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/** apps category */
export enum AppCategoryEnum {
  PLUGIN = "PLUGIN",
  TEMPLATE = "TEMPLATE",
}

/** agent report level */
export enum AgentReportLevelEnum {
  HIGH = "HIGH",
  MID = "MID",
  LOW = "LOW",
}

/** agent report category */
export enum AgentReportCategoryEnum {
  STOCK = "STOCK",
  CRYPTO = "CRYPTO",
}

/** type */
export enum QuotaBusinessTypeEnum {
  USER_AMOUNT = "USER_AMOUNT",
  USER_TIMES = "USER_TIMES",
  POLICY_AMOUNT = "POLICY_AMOUNT",
  POLICY_TIMES = "POLICY_TIMES",
  POLICY_ADDRESS_COUNT = "POLICY_ADDRESS_COUNT",
  USER_AMOUNT_USD = "USER_AMOUNT_USD",
  POLICY_AMOUNT_USD = "POLICY_AMOUNT_USD",
}

/** business type status */
export enum BusinessType {
  GAS_STATION = "GAS_STATION",
}

/** token usage */
export enum PayBusinessType {
  EDGEN_SUB = "EDGEN_SUB",
  REFUND = "REFUND",
}

/** pay status */
export enum PaymentPlanStatus {
  APPROVAL_PENDING = "APPROVAL_PENDING",
  APPROVED = "APPROVED",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED",
}

/** Payment channel */
export enum PayChannel {
  PAYPAL = "PAYPAL",
  WALLET = "WALLET",
  STRIPE = "STRIPE",
  APPLE_IAP = "APPLE_IAP",
  GOOGLE_IAP = "GOOGLE_IAP",
  AIRWALLEX = "AIRWALLEX",
}

/** token usage */
export enum PayType {
  CONTINUOUS = "CONTINUOUS",
  NON_CONTINUOUS = "NON_CONTINUOUS",
}

/** theme status enum */
export enum ThemeStatusEnum {
  EDIT = "EDIT",
  RELEASE = "RELEASE",
  USE = "USE",
}

/** token usage */
export enum TokenUsageEnum {
  SUBSCRIBE = "SUBSCRIBE",
}

/** transaction type */
export enum TransactionTypeEnum {
  ALL = "ALL",
  FROM = "FROM",
  TO = "TO",
}

/** transaction status */
export enum QueryTypeEnum {
  GAS = "GAS",
  OSP = "OSP",
  ALL = "ALL",
}

/** transaction status */
export enum TransactionStatusEnum {
  PENDING = "PENDING",
  FINISHED = "FINISHED",
  FAILED = "FAILED",
  CANCEL = "CANCEL",
}

/** dapp type */
export enum DappTypeEnum {
  WE_SPACE = "WE_SPACE",
  ME_SPACE = "ME_SPACE",
}

/** domain verification */
export enum DomainTypeEnum {
  TXT = "TXT",
  CNAME = "CNAME",
}

/** device type enum */
export enum BaseMetaTypeEnum {
  Profile = "profile",
  Community = "community",
  Badge = "badge",
}

/** join module enum */
export enum JoinModuleEnum {
  NULL_JOIN_MODULE = "NULL_JOIN_MODULE",
  ERC20_FEE_JOIN_MODULE = "ERC20_FEE_JOIN_MODULE",
  HOLD_TOKEN_JOIN_MODULE = "HOLD_TOKEN_JOIN_MODULE",
  NATIVE_FEE_JOIN_MODULE = "NATIVE_FEE_JOIN_MODULE",
}

/** hide type */
export enum ReportTypeEnum {
  REPORT = "REPORT",
  NOT_INTERESTED_IN = "NOT_INTERESTED_IN",
  USER = "USER",
}

/** relation status enum */
export enum RelationStatusEnum {
  ENABLE = "ENABLE",
  DISABLE = "DISABLE",
}

/** relation ranking enum */
export enum RelationRankingEnum {
  ROLE = "ROLE",
  CREATED = "CREATED",
  LATEST_POST_TIME = "LATEST_POST_TIME",
}

/** relation role enum */
export enum RelationRoleEnum {
  OWNER = "OWNER",
  MEMBER = "MEMBER",
  ADMIN = "ADMIN",
  MODERATOR = "MODERATOR",
}

/** relation enum */
export enum RelationEnum {
  JOIN = "JOIN",
  FOLLOW = "FOLLOW",
  BLOCK = "BLOCK",
  SUBSCRIBE = "SUBSCRIBE",
  INVITE = "INVITE",
}

/** megaphone status */
export enum MegaphoneStatusEnum {
  NOTSTARTED = "NOTSTARTED",
  PROGRESS = "PROGRESS",
  FINISHED = "FINISHED",
}

/** reaction ranking type */
export enum ReactionRankingEnum {
  TIME = "TIME",
  HOT = "HOT",
  TOP = "TOP",
}

/** reaction kind */
export enum ReactionSubKindEnum {
  UPVOTE = "UPVOTE",
  DOWNVOTE = "DOWNVOTE",
  UPHIGHLIGHT = "UPHIGHLIGHT",
  DOWNHIGHLIGHT = "DOWNHIGHLIGHT",
}

/** reaction kind */
export enum ReactionKindEnum {
  LIKE = "LIKE",
  VOTE = "VOTE",
  MEGAPHONE = "MEGAPHONE",
  TRIBE_BLOCK = "TRIBE_BLOCK",
  TRIBE_PIN = "TRIBE_PIN",
  USER_BLOCK = "USER_BLOCK",
  USER_PIN = "USER_PIN",
  HIGHLIGHT = "HIGHLIGHT",
  TIPPING = "TIPPING",
  VERIFY_QUEST = "VERIFY_QUEST",
  SCORE = "SCORE",
}

/** community ranking type */
export enum CommunityRankingEnum {
  ORDER = "ORDER",
  MODIFIED = "MODIFIED",
  CREATED = "CREATED",
  RECOMMEND = "RECOMMEND",
  DRAFT_TIME = "DRAFT_TIME",
  MEMBER_COUNT = "MEMBER_COUNT",
}

/** chat group type */
export enum ChatGroupType {
  Public = "public",
  Private = "private",
}

/** type */
export enum ChatGroupChannel {
  TELEGRAM = "TELEGRAM",
}

/** nft asset type */
export enum AssetTypeEnum {
  NFT = "NFT",
  JOIN_NFT = "JOIN_NFT",
  TRIBE_NFT = "TRIBE_NFT",
  SBT = "SBT",
}

/** profile rank kind */
export enum ProfileRankingEnum {
  RECOMMEND = "RECOMMEND",
}

/** activity status */
export enum FeedStatusEnum {
  NORMAL = "NORMAL",
  INNER = "INNER",
  STOP = "STOP",
}

/** activity category */
export enum CategoryEnum {
  POST = "POST",
  COMMENT = "COMMENT",
  ANSWER = "ANSWER",
  QUESTION = "QUESTION",
  WISH = "WISH",
  QUEST = "QUEST",
  ARTICLE = "ARTICLE",
}

/** activity category */
export enum ActivityCategoryEnum {
  POST = "POST",
  QUESTION = "QUESTION",
  POLL = "POLL",
  COMMENT = "COMMENT",
}

/** transaction status */
export enum OwnerStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/** ThirdAuthSource */
export enum ThirdAuthSourceEnum {
  EXTERNAL_WALLET = "EXTERNAL_WALLET",
  EXTERNAL_SOCIAL = "EXTERNAL_SOCIAL",
}

/** device type */
export enum DeviceType {
  PC = "PC",
  PWA = "PWA",
  IOS = "IOS",
  ANDROID = "ANDROID",
}

/** sync status enum */
export enum SyncStatus {
  UNSYNC = "UNSYNC",
  SYNCING = "SYNCING",
  SYNCED = "SYNCED",
}

export interface BaseResponse {
  /** sub code */
  code?: number;
  /** information for the response */
  msg?: string;
  data?: object;
  errors?: Error[];
}

export interface Error {
  /** error type, eg. Generic, InvalidRequest, ClientForbidden */
  reason?: string;
  /** human-friendly message */
  detail?: string;
  /** chart */
  location?: string;
  /** parameter */
  locationType?: string;
}

export interface Media {
  /** id for resource */
  id?: string;
  /** media url */
  display_url?: string;
  /** media url */
  media_url?: string;
  /** http url */
  media_url_https?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  type?: string;
  /** native/twitter/giphy */
  source?: string;
  /** link */
  link?: string;
  /** url */
  url?: string;
  /** json format sizes */
  sizes?: string;
  /** extra cover url */
  extra?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  mime_type?: string;
  /** cover url */
  cover?: string;
}

export interface NFT {
  /** nft name */
  name?: string;
  /** nft link for opensocial */
  external_url?: string;
  /** nft image url, ipfs link */
  image?: string;
  /** nft animation url, ipfs link */
  animation_url?: string;
  /** nft desc */
  description?: string;
  attributes?: NFTAttribute[];
}

export interface NFTAttribute {
  /** trait_type */
  trait_type?: string;
  /** display_type */
  display_type?: string;
  /** value */
  value?: string;
}

export interface Url {
  /** url */
  url?: string;
  /** og or twitter title */
  title?: string;
  /** og or twitter description */
  description?: string;
  /** og or twitter image */
  image?: string;
  /** html content */
  html?: string;
  /** article_id of content */
  article_id?: string;
  /** articleAuthor handle content */
  article_author?: string;
  /** article_author_avtar */
  article_author_avtar?: string;
  /** article_author_display_name */
  article_author_display_name?: string;
}

export interface Mention {
  /** profileId */
  profileId?: string;
  /** ospAddress */
  osp_address?: string;
  /** user handle */
  handle?: string;
}

export interface Chain {
  /**
   * chain id
   * @format int32
   */
  id?: number;
  /** chain name */
  name?: string;
  /** chain icon */
  icon?: string;
  /** explorer url */
  explorer_url?: string;
  /** rpc url */
  rpc_url?: string;
  /** Yes or No OSP */
  osp?: boolean;
  /** activity signer address */
  activity_signer_address?: string;
  supported_tokens?: CurrencyToken[];
}

export interface CurrencyToken {
  /** token symbol */
  symbol?: string;
  /** token name */
  name?: string;
  /** token address */
  address?: string;
  /** erc20/native */
  type?: string;
  /** icon url */
  icon?: string;
  /**
   * precious
   * @format int32
   */
  decimals?: number;
  /**
   * chain id
   * @format int32
   */
  chain_id?: number;
  /** gas/osp */
  supported_account_type?: string[];
}

export interface Symbol {
  /** symbol icon */
  icon?: string;
  /** symbol name */
  name?: string;
  /** sentiment type eg BULLISH|BEARISH|NEUTRAL */
  sentiment_type?: string;
}

export interface Challenge {
  /** text to sign */
  text?: string;
}

export type ChallengeResponse = BaseResponse & {
  data?: Challenge;
};

export interface AccessToken {
  /** 30 minutes access token */
  access_token?: string;
  /** 7 days refresh token */
  refresh_token?: string;
}

export type TokenResponse = BaseResponse & {
  data?: AccessToken;
};

export interface AuthRequest {
  /** sign message by challenge text */
  signature: string;
  /** address */
  eoa_address?: string;
  /** IssuePlatform */
  issue_platform?: string;
  /** Issue Channel such as WALLET, FIREBASE */
  issue_channel?: string;
}

export interface IdToken {
  /** the user identifier token */
  id_token?: string;
}

export type IdTokenResponse = BaseResponse & {
  data?: IdToken;
};

export interface SessionLoginRequest {
  /** sign message by challenge text */
  signature: string;
  /** address */
  osp_address?: string;
}

export interface WalletLoginRequest {
  /** sign message by challenge text */
  signature: string;
  /** address */
  wallet_address?: string;
  /** IssuePlatform */
  issue_platform?: string;
}

/** Owner info */
export interface Owner {
  /** id */
  id?: string;
  /** osp_address */
  osp_address?: string;
  /** eoa_address */
  eoa_address?: string;
  /** issue_channel */
  issue_channel?: string;
  /** issue_platform */
  issue_platform?: string;
  /** handle */
  issue_name?: string;
  /** issue email */
  issue_email?: string;
  /** language */
  locale?: string;
  /**
   * Ed 称呼用户的昵称；ksocial social_owner_v4.nick_name。未设置则省略。
   * @maxLength 64
   */
  nick_name?: string;
  /** issue avatar */
  avatar?: string;
  /** transaction status */
  status?: OwnerStatusEnum;
  /** app_id */
  app_id?: string;
  /**
   * deposit code
   * @deprecated
   */
  deposit_code?: string;
  /** deposit code */
  unique_code?: string;
  /**
   * Invited Count
   * @format int64
   */
  invited_count?: number;
  profile?: Profile[];
  /**
   * register time
   * @format int64
   */
  register_time?: number;
  member?: Member;
}

export type OwnerResponse = BaseResponse & {
  /** Owner info */
  data?: Owner;
};

export interface OwnerPagination {
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int32
   */
  total?: number;
  /** 翻页token */
  next_token?: string;
  rows?: Owner[];
}

export type OwnerPaginationResponse = BaseResponse & {
  data?: OwnerPagination;
};

export interface Activity {
  /** profile info */
  profile?: Profile;
  /** IPFS url */
  content_uri?: string;
  title?: string;
  text?: string;
  summary?: string;
  profile_id?: string;
  user_gid?: string;
  view_id?: string;
  /** chain content id */
  content_id?: string;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  share_count?: number;
  /** @format int64 */
  like_count?: number;
  /** @format int64 */
  comment_count?: number;
  /** @format int64 */
  favorite_count?: number;
  /** @format int64 */
  view_count?: number;
  /** @format int64 */
  upvote_count?: number;
  /** @format int64 */
  downvote_count?: number;
  community_id?: string;
  community_gid?: string;
  /** index id ,use mark data */
  index_id?: string;
  /** sync status */
  sync_status?: SyncStatus;
  medias?: Media[];
  urls?: Url[];
  mentions?: Mention[];
  /** content */
  content?: string;
  /** reference_condition */
  reference_condition?: string;
  /** extension_address */
  extension_address?: string;
  /** extension_data */
  extension_data?: string;
  /** extension info */
  extensions?: string;
}

export type ActivityResponse = BaseResponse & {
  data?: Activity;
};

export type ActivityPrivacyResponse = BaseResponse & {
  data?: ActivityPrivacy;
};

export interface ActivityPrivacy {
  allow_view?: boolean;
  privacy_content_url?: string;
  privacy_content?: string;
  privacy_medias?: Media[];
  nft_contract_address?: string;
  is_subscription?: boolean;
}

export interface ActivityPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Activity[];
}

export type ActivityPaginationResponse = BaseResponse & {
  data?: ActivityPagination;
};

export interface AddActivityRequest {
  /** The hexadecimal community id */
  community_id?: string;
  /**
   * The metadata uploaded somewhere passing in the url to reach it, by
   * @format uri
   */
  content_uri?: string;
  /** content_uri include info JSON to string */
  content?: string;
}

export interface GetActivitiesRequest {
  /**
   * The amount of activities requested from the APIs
   * @format int32
   * @max 20
   * @default 5
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  chain_status?: number;
  /** filter activity category */
  categories?: ActivityCategoryEnum[];
  /** The app_ids Ids */
  app_ids?: string[];
  /** {profile_id}_{content_id} */
  profile_contents?: string[];
  /** view id */
  view_ids?: string[];
  /** profile_id */
  profile_id?: string;
  /**
   * 只返回简单信息
   * @example true
   */
  simple?: boolean;
}

export interface UpdateActivityRequest {
  /**
   * tag id
   * @maxItems 5
   */
  tags?: string[];
}

export interface FeedEnrichOption {
  /** enable enrich */
  enable?: boolean;
  /** with reaction count */
  with_reaction_counts?: boolean;
  /** with join role */
  with_profile_joining_role?: boolean;
  /** with own reactions */
  with_own_reaction_kinds?: ReactionKindEnum[];
  /** Include reactions information */
  with_reactions?: string[];
  /**
   * with reactions limit
   * @min 0
   * @max 20
   * @default 0
   */
  reaction_limit?: number;
  /** Include child reactions information */
  with_children?: string[];
  /**
   * with children reactions of reactions limit
   * @min 0
   * @max 20
   * @default 0
   */
  children_limit?: number;
  /**
   * Include profile information
   * @example false
   */
  with_profile?: boolean;
  /**
   * Include community information
   * @example false
   */
  with_community?: boolean;
  /** Include relationship information */
  with_relations?: RelationEnum[];
  /**
   * Include activity information
   * @example false
   */
  with_target?: boolean;
  /**
   * Include target information
   * @example false
   */
  with_parent?: boolean;
  /** @example false */
  with_activity?: boolean;
}

export interface Feed {
  /** Display content ID */
  view_id?: string;
  /** Chain content ID */
  content_id?: string;
  /** Profile ID */
  profile_id?: string;
  /** user global id */
  user_gid?: string;
  /** activity status */
  status?: FeedStatusEnum;
  /** activity category */
  category?: CategoryEnum;
  /** Title */
  title?: string;
  /** Summary content */
  summary?: string;
  /** Full content */
  text?: string;
  medias?: Media[];
  /** Theme content */
  community_id?: string;
  /** community_gid */
  community_gid?: string;
  /**
   * Creation time
   * @format int64
   */
  created?: number;
  /**
   * Modification time
   * @format int64
   */
  modified?: number;
  /**
   * Share count
   * @format int64
   */
  share_count?: number;
  /**
   * Like count
   * @format int64
   */
  like_count?: number;
  /**
   * Comment count
   * @format int64
   */
  comment_count?: number;
  /**
   * Favorite count
   * @format int64
   */
  favorite_count?: number;
  /**
   * View count
   * @format int64
   */
  view_count?: number;
  /**
   * Upvote count
   * @format int64
   */
  upvote_count?: number;
  /**
   * Downvote count
   * @format int64
   */
  downvote_count?: number;
  /** Whether creator is blocked */
  blocking?: boolean;
  /** Whether following creator */
  following?: boolean;
  /** profile info */
  profile?: Profile;
  /** Recent interactions list */
  reactions?: Record<string, Reaction[]>;
  /** Recent child content list */
  children?: Record<string, Activity[]>;
  /** Whether interaction exists */
  owns?: Record<string, Reaction>;
  activity?: Activity;
  target?: Activity;
  /** community info */
  community?: Community;
  /** Relationship between logged-in user and returned user */
  relations?: RelationEnum[];
  /** Index ID for data marking */
  index_id?: string;
  /** sync status enum */
  sync_status?: SyncStatus;
  /** IPFS URL */
  content_uri?: string;
  /**
   * Megaphone count
   * @format int64
   */
  megaphone_count?: number;
  urls?: Url[];
  mentions?: Mention[];
  /** Content */
  content?: string;
  /** Reference condition */
  reference_condition?: string;
  /** Impression ID */
  impression_id?: string;
  /** Promoted ID */
  promoted_id?: string;
  /** Extension address */
  extension_address?: string;
  /** Extension data */
  extension_data?: string;
  /** Extension info */
  extensions?: string;
  /**
   * Highlight time
   * @format int64
   */
  highlight_time?: number;
  /**
   * Latest upvote time
   * @format int64
   */
  latest_upvote_time?: number;
  /**
   * Privacy post (1)
   * @format int64
   */
  privacy?: number;
  /**
   * Media conversion status (0=in progress, 1=complete)
   * @format int64
   */
  media_status?: number;
  /** activity category */
  sub_category?: CategoryEnum;
  /** Statistics */
  stats?: object;
  symbol?: Symbol[];
  /** kline */
  kline?: object;
  /** Language */
  language?: string;
}

export interface FeedPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int32
   */
  total?: number;
  /** 翻页token */
  next_token?: string;
  rows?: Feed[];
}

export type FeedPaginationResponse = BaseResponse & {
  data?: FeedPagination;
};

export type FeedResponse = BaseResponse & {
  data?: Feed;
};

export interface ListFeedRequest {
  /**
   * The amount of activities requested from the APIs
   * @format int32
   * @default 5
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  /**
   * include feed id list
   * @maxItems 10
   */
  ids?: string[];
  /** communityId */
  community_id?: string;
  enrich?: FeedEnrichOption;
  /** feed params for flat */
  params?: Record<string, any>;
  /** filter */
  filter?: FeedFilterOption;
}

export interface FeedFilterOption {
  /** @maxItems 5 */
  exclude_own_reactions?: ReactionKindEnum[];
  /**
   * exclude community ids
   * @maxItems 5
   */
  exclude_communities?: string[];
}

/** profile info */
export interface Profile {
  /** user gid */
  gid?: string;
  chain_id?: string;
  /** profile id */
  profile_id?: string;
  handle?: string;
  bio?: string;
  background?: string;
  /** picture(url,height/width/mimeType...) or NftImage(contractAddress,tokenId,uri) */
  avatar?: string;
  /** todo support? */
  metadata?: object;
  /**
   * owner id
   * @deprecated
   */
  owner?: string;
  /** owner address */
  address?: string;
  attributes?: ProfileAttribute[];
  /** Wear Badge */
  badge?: Badge;
  dispatcher?: Dispatcher;
  /** The follow Condition */
  follow_condition?: object;
  /** Follow nft address */
  follow_nft_address?: string;
  /**
   * 0=unfollow,1=off_chain follow, 2=on_chain follow
   * @format int64
   */
  following?: number;
  /** following token id */
  following_token_id?: string;
  /**
   * 0=unfollow,1=off_chain follow, 2=on_chain follow
   * @format int64
   */
  followed?: number;
  /** @format int64 */
  following_count?: number;
  /** @format int64 */
  chain_following_count?: number;
  /** @format int64 */
  follower_count?: number;
  /** @format int64 */
  chain_follower_count?: number;
  /** @format int64 */
  subscribe_count?: number;
  /** @format int64 */
  activity_count?: number;
  /** @format int64 */
  join_count?: number;
  /** @format int64 */
  activity_like_count?: number;
  /** index id ,use mark data */
  index_id?: string;
  /** user id eq profile id */
  user_id?: string;
  /** displayName or nickName */
  nick_name?: string;
  unique_name?: string;
  /** @format int64 */
  created?: number;
  /** sync status enum */
  sync_status?: SyncStatus;
  /** join tribe role */
  joining_role?: RelationRoleEnum;
  joining_level?: string;
  /** stats */
  stats?: object;
  /** @format int64 */
  post_count?: number;
  /**
   * the count of user score
   * @format int64
   */
  user_date_score_count?: number;
  /** owner information */
  owner_info?: Owner;
}

export interface ProfileAttribute {
  /** The display type */
  display_type?: string;
  /** identifier of this attribute, we will update by this id */
  key?: string;
  /** The trait type - can be anything its the name it will render so include spaces */
  trait_type?: string;
  /** Value attribute */
  value?: string;
}

export type ProfileResponse = BaseResponse & {
  /** profile info */
  data?: Profile;
};

export interface ProfilePagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Profile[];
}

export type ProfilePaginationResponse = BaseResponse & {
  data?: ProfilePagination;
};

/** Wear Badge */
export interface Badge {
  /** id */
  id?: string;
  /** name */
  name?: string;
  /** chain id */
  icon?: string;
  /** level */
  level?: number;
  /**
   * created
   * @format int64
   */
  created?: number;
}

export interface Dispatcher {
  /** wallet address of dispatcher */
  address?: string;
  /** use the built-in dispatcher on the API */
  canRelay?: boolean;
}

export interface ListProfileRequest {
  /** eoa address */
  eoa_address?: string;
  /** user owner wallet address */
  address?: string;
  /**
   * user handle
   * @maxItems 20
   */
  handles?: string[];
  /**
   * owner ids
   * @maxItems 20
   */
  owner_ids?: string[];
  /**
   * user id
   * @maxItems 20
   */
  ids?: string[];
  /** inviter owner id -  inviter */
  inviter_owner_id?: string;
  /** nextToken for pagination */
  next_token?: string;
  /**
   * limit for pagination
   * @format int32
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
}

/** Asset Info */
export interface Asset {
  /** contract address */
  contract_address?: string;
  /** token id */
  token_id?: string;
  /** chain id */
  chain_id?: number;
  nft?: NFT;
}

export interface AssetPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Asset[];
}

export type AssetPaginationResponse = BaseResponse & {
  data?: AssetPagination;
};

export interface SocialMedia {
  /** id for resource */
  id?: string;
  /** media url */
  display_url?: string;
  /** media url */
  media_url?: string;
  /** http url */
  media_url_https?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  type?: string;
  /** native/twitter/giphy */
  source?: string;
  /** link */
  link?: string;
  /** url */
  url?: string;
  /** json format sizes */
  sizes?: string;
  /** extra cover url */
  extra?: string;
  /** activity_id */
  activity_id?: string;
  /** profile_id */
  profile_id?: string;
  /** user_gid */
  user_gid?: string;
  /** @format int64 */
  activity_time?: number;
  /**
   * 1-privacy post
   * @format int64
   */
  privacy?: number;
  /**
   * media status
   * @format int64
   */
  media_status?: number;
}

/** media list */
export interface ListMediaRequest {
  /**
   * @min 1
   * @max 20
   */
  limit?: number;
  next_token?: string;
}

export interface MediaPagination {
  /**
   * Number of items per request
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * Total number of pages returned, default is 0 if not querying total pages
   * @format int32
   */
  total?: number;
  /** Pagination token */
  next_token?: string;
  rows?: SocialMedia[];
}

export type MediaPaginationResponse = BaseResponse & {
  data?: MediaPagination;
};

export interface UpdateProfileRequest {
  /** nick_name */
  nick_name?: string;
  /** avatar */
  avatar?: string;
  /** background desc */
  background?: string;
  /** intro */
  intro?: string;
  /** badge id */
  badge_id?: string;
}

/** chat group list */
export interface ChatGroup {
  /** group id */
  id?: string;
  /** channel */
  channel?: ChatGroupChannel;
  /** public or private */
  type?: ChatGroupType;
  /** invite link */
  invite_link?: string;
  /** group title */
  title?: string;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modified?: number;
}

/** community info */
export interface Community {
  /** community gid */
  gid?: string;
  /** Community ID */
  id?: string;
  /** Community unique name */
  handle?: string;
  /** display */
  display_name?: string;
  /** Description */
  desc?: string;
  /** banner url */
  banner?: string;
  /** template id */
  template?: string;
  /** Creator user ID */
  profile_id?: string;
  /** user_gid */
  user_gid?: string;
  /** logo */
  logo?: string;
  /**
   * Number of posts
   * @format int64
   */
  activity_count?: number;
  /**
   * Number of community followers
   * @format int64
   */
  member_count?: number;
  /** profile info */
  profile?: Profile;
  /** isJoining */
  joining?: boolean;
  /**
   * joining_status 0 Not joined, 1 Joined, 2 Blacklisted
   * @format int64
   */
  joining_status?: number;
  /**
   * subscribe_status 0 not subscribed, 1 subscribed
   * @format int64
   */
  subscribe_status?: number;
  /** @format int64 */
  modified?: number;
  /** @format int64 */
  draft_time?: number;
  /** join token id */
  join_token_id?: string;
  /** join_nft */
  join_nft?: string;
  nft?: NFT;
  tags?: string[];
  /** bind domain name */
  domain?: string;
  /** template_body */
  template_body?: string;
  /** join condition details */
  join_condition_details?: object;
  /** activity condition details */
  activity_condition?: object;
  /** activity_condition address */
  activity_condition_address?: string;
  /** allow_activity  0 not allow/ 1 allow */
  allow_activity?: number;
  activity_extension_address?: string[];
  /** activity post condition */
  activity_post_condition?: string;
  /** view privacy post condition */
  view_privacy_condition?: string;
  /** language data */
  language?: string;
  /** token_id data */
  token_id?: string;
  rules?: string[];
  activity_tags?: string[];
  /** index id ,use mark data */
  index_id?: string;
  chat_groups?: ChatGroup[];
  /** sync status enum */
  sync_status?: SyncStatus;
  /** join tribe role */
  role?: RelationRoleEnum;
  /** join tribe role */
  joining_role?: RelationRoleEnum;
  joining_level?: string;
  /**
   * community latest post time
   * @format int64
   */
  latest_post_time?: number;
  /** bind_app_id */
  bind_app_id?: string;
  /** app_id */
  app_id?: string;
  /** address */
  address?: string;
}

export interface CommunityPagination {
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int32
   */
  total?: number;
  /** 翻页token */
  next_token?: string;
  rows?: Community[];
}

export type CommunityPaginationResponse = BaseResponse & {
  data?: CommunityPagination;
};

export type CommunityResponse = BaseResponse & {
  /** community info */
  data?: Community;
};

/** query communities */
export interface ListCommunityRequest {
  /** community ranking type */
  ranking: CommunityRankingEnum;
  /**
   * query by custom domain/hostname
   * @maxItems 20
   */
  ids?: string[];
  /**
   * query by handle
   * @maxItems 20
   */
  handles?: string[];
  /**
   * @min 1
   * @max 20
   * @default 5
   */
  limit: number;
  /** @format int64 */
  begin_time?: number;
  next_token?: string;
  /**
   * community creator
   * @default false
   */
  with_profile?: boolean;
  profile_id?: string;
  /**
   * tag list
   * @maxItems 20
   */
  tags?: string[];
  language?: string;
  /** search  join_condition_address */
  join_condition_address?: string;
  /** 需要查询的与当前登录用户的relation */
  with_relations?: RelationEnum[];
  /**
   * exclude have join community
   * @default false
   */
  exclude_own?: boolean;
  /**
   * include already upgraded dapp
   * @default false
   */
  exclude_bind_app?: boolean;
  /** bind_app enum */
  bind_app?: "IGNORE" | "PRESENT" | "ABSENT";
}

export interface UpdateCommunityRequest {
  /** show name */
  display_name?: string;
  /** community desc */
  desc?: string;
  desc_medias?: Media[];
  /** logo url */
  logo?: string;
  /** banner url */
  banner?: string;
  /** language */
  language?: string;
  /** rules */
  rules?: string[];
  /**
   * activity_tags
   * @maxItems 20
   */
  activity_tags?: string[];
  token_id?: string;
  handle?: string;
  /** community role name . key id relation roleEnum name */
  roles?: Record<string, string>;
}

export interface CommunityTag {
  /** tag name */
  name?: string;
  /** icon */
  icon?: string;
}

export interface CommunityTagPagination {
  /**
   * Number of items per request
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * Total number of pages returned, default is 0 if not querying total pages
   * @format int32
   */
  total?: number;
  /** Pagination token */
  next_token?: string;
  rows?: CommunityTag[];
}

export type CommunityTagPaginationResponse = BaseResponse & {
  data?: CommunityTagPagination;
};

export interface CommunityEnrichOption {
  /**
   * Whether to return creator information
   * @example false
   */
  with_profile?: boolean;
  /** The relation to query with the current logged-in user */
  with_relations?: RelationEnum[];
}

export interface SearchCommunityRequest {
  /**
   * The community of get request from the APIS
   * @format int32
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  profile_id?: string;
  enrich_option?: CommunityEnrichOption;
  /** get community params for flat */
  params?: Record<string, any>;
}

export type CommunityContributorResponse = BaseResponse & {
  data?: CommunityContributor;
};

export type CommunityContributor = Profile[];

export interface ListUserActionStatsRequest {
  /**
   * The popular user of get request from the APIS
   * @format int32
   * @min 1
   * @max 20
   * @default 3
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  /**
   * response user profile
   * @example false
   */
  with_profile?: boolean;
  /** response relation with current user */
  with_relations?: RelationEnum[];
}

export interface UserActionStatsPagination {
  /**
   * The amount of user action stats record requested from the APIs
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * record total count, default value is 0
   * @format int32
   */
  total?: number;
  /** next page token */
  next_token?: string;
  rows?: UserActionStats[];
}

export interface UserActionStats {
  /** user id */
  user_id?: string;
  /** chain id */
  chain_id?: string;
  /**
   * target id
   * @format int32
   */
  target_id?: string;
  /** target type */
  target_type?: string;
  /**
   * user stats in target
   * @format int32
   */
  action_count?: number;
  /** profile info */
  profile?: Profile;
}

export type UserActionStatsPaginationResponse = BaseResponse & {
  data?: UserActionStatsPagination;
};

export interface AddReactionRequest {
  referenced_profile_id?: string;
  referenced_content_id?: string;
  /**
   * display content id
   * @format string
   */
  referenced_view_id?: string;
  /** reaction kind */
  kind?: ReactionKindEnum;
  /** reaction kind */
  sub_kind?: ReactionSubKindEnum;
  score?: number;
}

/** reaction request */
export interface ListReactionRequest {
  /** reaction kind */
  kind?: ReactionKindEnum;
  /** reaction ranking type */
  ranking?: ReactionRankingEnum;
  /**
   * sort order reverse
   * @example false
   */
  reverse?: boolean;
  /**
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  next_token?: string;
  chain_status?: number;
  content_id?: string;
  /** @example false */
  with_activity?: boolean;
  /** @example false */
  with_profile?: boolean;
  /** @example false */
  with_target?: boolean;
  /** @example false */
  with_parent?: boolean;
  /**
   * exclude id list
   * @maxItems 5
   */
  exclude_ids?: string[];
  /** megaphone status */
  megaphone_status?: MegaphoneStatusEnum;
  activity_profile_id?: string;
}

export interface ReactionPagination {
  /**
   * limit
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** nextToken */
  next_token?: string;
  rows?: Reaction[];
}

export type ReactionPaginationResponse = BaseResponse & {
  data?: ReactionPagination;
};

export interface Reaction {
  /** id */
  id?: string;
  /** user id */
  profile_id?: string;
  /** user_gid */
  user_gid?: string;
  /** dispay content id */
  view_id?: string;
  /** chain content id */
  content_id?: string;
  /** @format int64 */
  created?: number;
  /**
   * like count
   * @format int64
   */
  like_count?: number;
  /**
   * 同意数
   * @format int64
   */
  upvote_count?: number;
  /**
   * 反对数
   * @format int64
   */
  downvote_count?: number;
  /** reaction kind */
  kind?: ReactionKindEnum;
  /** reaction kind */
  sub_kind?: ReactionSubKindEnum;
  /** profile info */
  profile?: Profile;
  target?: Activity;
  /** target view id */
  target_view_id?: string;
  data?: AdditionalData;
  activity?: Feed;
  /** index id ,use mark data */
  index_id?: string;
  /** sync status enum */
  sync_status?: SyncStatus;
  /** IPFS url */
  content_uri?: string;
  /** megaphone status */
  megaphone_status?: MegaphoneStatusEnum;
  /** megaphone data */
  extra?: string;
  /** communityId */
  community_id?: string;
  /** community_gid */
  community_gid?: string;
  /**
   * megaphone start time
   * @format int64
   */
  start_time?: number;
  /**
   * megaphone end time
   * @format int64
   */
  end_time?: number;
  extension_data?: string[];
}

export type ReactionResponse = BaseResponse & {
  data?: Reaction;
};

export interface AdditionalData {
  /** 带有内容的reaction，比如评论/回复 */
  text?: string;
  /** content */
  content?: string;
  medias?: Media[];
  /** 场景 */
  scene?: string;
  /** 互动目标ID */
  target?: string;
}

/** query relation */
export interface ListRelationRequest {
  /**
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  next_token?: string;
  /** @maxItems 20 */
  include_target_ids?: string[];
  /** relation ranking enum */
  ranking?: RelationRankingEnum;
  /** join tribe role */
  roles?: RelationRoleEnum[];
  /** join tribe role */
  joining_roles?: RelationRoleEnum[];
  /** relation status enum */
  status?: RelationStatusEnum;
  user_name?: string;
  level?: string;
  reverse?: boolean;
}

export interface Relation {
  /** id */
  id?: string;
  /** user_gid */
  user_gid?: string;
  /** user id */
  profile_id?: string;
  /** target_gid */
  target_gid?: string;
  /** target_id */
  target_id?: string;
  /** chain content id */
  content_id?: string;
  /**
   * chain content id
   * @format int64
   */
  relation?: number;
  /** @format int64 */
  created?: number;
  /** index id ,use mark data */
  index_id?: string;
  /** sync status enum */
  sync_status?: SyncStatus;
}

export type RelationResponse = BaseResponse & {
  data?: Relation;
};

export interface AddReportRequest {
  /** reported post id */
  target_view_id?: string;
  /** report reason */
  reason?: string;
  /** report desc */
  desc?: string;
  /** hide type */
  type?: ReportTypeEnum;
}

export type ReportResponse = BaseResponse & {
  data?: boolean;
};

export interface CredentialCreationOptionsRequest {
  /** Alias of passkey, should be unique */
  displayName: string;
}

export type PublicKeyCredentialCreationOptionsResponse = BaseResponse & {
  data?: PublicKeyCredentialCreationOptionsJSON;
};

export interface RegistrationVerificationRequest {
  /** Alias of passkey, should be unique */
  id: string;
  /** raw id of passkey */
  rawId: string;
  /** password of passkey wallet */
  password: string;
  /** device name */
  device_name?: string;
  /** auth type */
  auth_type?: number;
  response: {
    clientDataJSON: string;
    attestationObject: string;
    authenticatorData?: string;
    transports?: ("internal" | "usb" | "nfc" | "ble" | "hybrid" | "cable")[];
    publicKeyAlgorithm?: number;
    publicKey?: string;
  };
  authenticatorAttachment?: "platform" | "cross-platform";
  clientExtensionResults: {
    /** appid extension */
    appid?: boolean;
    credProps?: {
      rk?: boolean;
    };
  };
  type?: "public-key";
}

export type PublicKeyCredentialRequestOptionsResponse = BaseResponse & {
  data?: PublicKeyCredentialRequestOptionsJSON;
};

export interface AuthenticationVerificationRequest {
  /** Alias of passkey, should be unique */
  id: string;
  /** raw id of passkey */
  rawId: string;
  response: {
    clientDataJSON: string;
    authenticatorData: string;
    signature: string;
    userHandle?: string;
  };
  authenticatorAttachment?: "platform" | "cross-platform";
  clientExtensionResults: {
    /** appid extension */
    appid?: boolean;
    credProps?: {
      rk?: boolean;
    };
  };
  type?: "public-key";
}

export type AuthenticationVerificationResponse = BaseResponse & {
  data?: {
    password?: string;
  };
};

export interface PublicKeyCredentialCreationOptionsJSON {
  rp: {
    id?: string;
    name: string;
  };
  user: {
    id?: string;
    name?: string;
    displayName?: string;
  };
  challenge: string;
  pubKeyCredParams: {
    alg?: number;
    type?: "public-key";
  }[];
  timeout?: number;
  excludeCredentials?: {
    id?: string;
    type?: "public-key";
    transports?: ("internal" | "usb" | "nfc" | "ble" | "hybrid" | "cable")[];
  }[];
  authenticatorSelection?: {
    authenticatorAttachment?: "platform" | "cross-platform";
    requireResidentKey?: boolean;
    residentKey?: "required" | "preferred" | "discouraged";
    userVerification?: "discouraged" | "preferred" | "required";
  };
  attestation?: "none" | "indirect" | "direct" | "enterprise";
  extensions?: {
    appid?: string;
    credProps?: boolean;
    hmacCreateSecret?: boolean;
    minPinLength?: boolean;
  };
}

export interface PublicKeyCredentialRequestOptionsJSON {
  challenge: string;
  timeout?: number;
  rpId?: string;
  allowCredentials?: {
    id?: string;
    type?: "public-key";
    transports?: ("internal" | "usb" | "nfc" | "ble" | "hybrid" | "cable")[];
  }[];
  userVerification?: "discouraged" | "preferred" | "required";
  extensions?: {
    appid?: string;
    credProps?: boolean;
    hmacCreateSecret?: boolean;
  };
}

/** passkey info */
export interface PasskeyCredential {
  /** record id */
  id?: string;
  /** passkey owner */
  owner_id?: string;
  /** AA address */
  osp_address?: string;
  /** password */
  password?: string;
  /** device name */
  device_name?: string;
  /** auth type */
  auth_type?: number;
  /**
   * created time
   * @format int64
   */
  created?: number;
  /**
   * modified time
   * @format int64
   */
  modified?: number;
}

export interface ListPasskeyRequest {
  /** Alias of passkey, should be unique */
  id?: string;
  /**
   * The passkey of get request from the APIS
   * @format int32
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
}

export interface PasskeyPagination {
  /**
   * The amount of passkey requested from the APIs
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total count of record, default value is 0
   * @format int32
   */
  total?: number;
  /** next page token */
  next_token?: string;
  rows?: PasskeyCredential[];
}

export type PasskeyPaginationResponse = BaseResponse & {
  data?: PasskeyPagination;
};

export interface RecipientPercent {
  /** recipient contract address */
  recipient?: string;
  /**
   * should be between 1 and 100
   * @format float
   */
  percent?: number;
}

export interface JoinModule {
  /** join module enum */
  type: JoinModuleEnum;
  /** join module */
  init?: {
    null_join_module?: object;
    erc20_fee_join_module?: ERC20FeeJoinModule;
    native_fee_join_module?: NativeFeeJoinModule;
    hold_token_join_module?: HoldTokenJoinModule;
  };
}

export interface ERC20FeeJoinModule {
  /** currency contract address */
  currency_address?: string;
  /** It could have the entire precision of the Asset or be truncated to the last significant decimal */
  amount_uint?: string;
  /** The follow module recipient address */
  recipient_address?: string;
}

export interface NativeFeeJoinModule {
  /** It could have the entire precision of the Asset or be truncated to the last significant decimal */
  amount_uint?: string;
  /** The join module recipient address */
  recipient_address?: string;
}

export interface HoldTokenJoinModule {
  /** token contract address */
  token_address?: string;
  amount_uint?: string;
}

/** join module parameter */
export interface JoinModuleParam {
  /** join module enum */
  type: JoinModuleEnum;
  /** You only have to enter one  */
  data?: {
    null_join_module?: object;
    erc20_fee_join_module?: FeeModuleParamData;
    native_fee_join_module?: object;
    hold_token_join_module?: object;
  };
}

export interface FeeModuleParamData {
  /** currency contract address */
  currency_address?: string;
  /** It could have the entire precision of the Asset or be truncated to the last significant decimal */
  amount_uint?: string;
}

export interface Broadcast {
  tx_hash: string;
}

export type BroadcastResponse = BaseResponse & {
  data?: Broadcast;
};

export interface BroadcastRequest {
  id: string;
  signature: string;
}

export interface SyncRequest {
  tx_hash?: string;
  uo_hash?: string;
  topic?: string;
  index_id?: string;
  off_chain_id?: string;
  chain_id?: string;
  status?: "SUCCESS" | "FAIL" | "BEGIN";
}

export type TransactionResponse = BaseResponse & {
  data?: {
    /** txHash if success */
    tx_hash?: string;
    /** txId if indexed by relay */
    tx_id?: string;
    info?: object;
  };
};

export interface UserOperation {
  sender?: string;
  nonce?: string;
  init_code?: string;
  call_data?: string;
  call_gas_limit?: string;
  verification_gas_limit?: string;
  pre_verification_gas?: string;
  max_fee_per_gas?: string;
  max_priority_fee_per_gas?: string;
  paymaster_and_data?: string;
  signature?: string;
  policy_data?: string;
}

export type FillUserOperationResponse = BaseResponse & {
  data?: UserOperation;
};

export type EstimateUserOperationResponse = BaseResponse & {
  data?: UserOperation;
};

export interface ZkTransaction {
  tx_type?: string;
  from?: string;
  to?: string;
  gas_limit?: string;
  gas_per_pubdata_byte_limit?: string;
  max_fee_per_gas?: string;
  max_priority_fee_per_gas?: string;
  paymaster?: string;
  nonce?: string;
  value?: string;
  data?: string;
  signature?: string;
  factory_deps?: string[];
  paymaster_input?: string;
  policy_data?: string;
}

export type FillZkSyncResponse = BaseResponse & {
  data?: ZkTransaction;
};

export type ZKInitDataResponse = BaseResponse & {
  data?: {
    account_factory?: string;
    init_call_data?: string;
  };
};

export interface AssetChange {
  asset_type: "NATIVE" | "ERC20" | "ERC721";
  /** (Optional) Asset contract address.Present only if property type is ERC20. */
  asset_address?: string;
  /** The address of the sender in an action of a transfer. */
  from: string;
  /** The address of the receiver in an action of a transfer. */
  to: string;
  /** The raw amount of the change. */
  raw_amount: string;
  /** (Optional) Number of decimals in the token. */
  decimals?: number;
  /** (Optional) The amount converted from the raw amount according to the decimals. Present only if property decimals is available. */
  amount?: string;
}

export type AssetChangeResponse = BaseResponse & {
  data?: {
    status?: boolean;
    asset_changes?: AssetChange[];
    revert_reason?: string;
  };
};

export interface SimulationTxRequest {
  from: string;
  to: string;
  value: string;
  call_data: string;
  block_number?: string;
  chain_id?: string;
}

export interface ListDappRequest {
  /**
   * The dapp of get request from the APIS
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  domain?: string;
  tag?: string;
  /** get dapp params for flat */
  params?: Record<string, any>;
  /** eoaAddress */
  eoa_address?: string;
  /** ownerId */
  owner_id?: string;
  /** ospAddress */
  osp_address?: string;
}

export type DappResponse = BaseResponse & {
  /** app info */
  data?: Dapp;
};

/** app info */
export interface Dapp {
  /** app */
  id?: string;
  /** app owner address */
  owner?: string;
  /** tribe display name */
  name?: string;
  tribe_owner?: TribeOwner;
  /** community id */
  community_id?: string;
  /** provisional ,delete after */
  chain_id?: string;
  /** tribe handle */
  handle?: string;
  /** community info */
  community?: Community;
  chain?: DappChain;
  /** app desc */
  desc?: string;
  /** @format int64 */
  modified?: number;
  /** @format int64 */
  created?: number;
  /** app theme_id */
  theme_id?: string;
  domains?: string[];
  reason?: string;
  /** app banner */
  banner?: string;
  sort?: number;
  /** background data */
  background?: string;
  /** twitter handle */
  twitter_handle?: string;
  /** tiktok handle */
  tiktok_handle?: string;
  /** instagram handle */
  instagram_handle?: string;
  /** youtube handle */
  youtube_handle?: string;
  have_credential?: boolean;
  /** dapp type */
  type?: DappTypeEnum;
  /** web3auth_signature */
  web3auth_signature?: string;
}

export interface DappPagination {
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int32
   */
  total?: number;
  /** 翻页token */
  next_token?: string;
  rows?: Dapp[];
}

export type DappPaginationResponse = BaseResponse & {
  data?: DappPagination;
};

export type DappDomainResponse = BaseResponse & {
  data?: DappDomainResult;
};

export interface DappDomainResult {
  /** sub code */
  code?: number;
  /** name */
  name?: string;
  /** value */
  value?: string;
  /** domain verification */
  type?: DomainTypeEnum;
}

export interface DappChain {
  /**
   * chain id
   * @format int32
   */
  chain_id?: number;
  /**
   * chain id
   * @format int32
   */
  id?: number;
  /** chain name */
  name?: string;
  /** chain icon */
  icon?: string;
}

export interface TribeOwner {
  /** owner address */
  address?: string;
  /** owner avatar */
  avatar?: string;
  /** owner handle */
  handle?: string;
}

export interface UpdateDappRequest {
  /** theme_id */
  theme_id?: string;
  /** background data */
  background?: string;
  /** background data */
  desc?: string;
}

export interface CreateDappRequest {
  /** community id */
  community_id?: string;
  /** theme_id */
  theme_id?: string;
  /** background data */
  background?: string;
  /** dapp type */
  type?: DappTypeEnum;
}

export interface WalletSignRequest {
  /**
   * The EOA address to receive the rebate
   * @example "0x1234567890123456789012345678901234567890"
   */
  eoa_address?: string;
  /**
   * rebate type
   * @example "MEMBER"
   */
  type?: string;
  /** sign type example PAYMENT,CLAIM */
  sign_type?: string;
  /** Payment product id (member) */
  product_id?: string;
  /** @format int32 */
  chain_id?: number;
  /** The token address */
  token_address?: string;
}

export type WalletSignResponse = BaseResponse & {
  data?: WalletSign;
};

export interface WalletSign {
  /** call data */
  call_data?: string;
  /** value */
  value?: string;
  /** target address */
  target_address?: string;
}

export interface Account {
  /** osp_address id */
  osp_address?: string;
  /** profile id */
  profile_id?: string;
  /** gas */
  type?: string;
  /** deposit code */
  code?: string;
  /** sign code */
  sign?: string;
  /** balance amount */
  balance?: Amount[];
  min_deposit_amount?: Amount;
}

export type AccountResponse = BaseResponse & {
  data?: Account;
};

export interface Amount {
  /** amount value */
  value?: string;
  /** token symbol */
  symbol?: string;
}

export interface AccountPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Account[];
}

export type AccountPaginationResponse = BaseResponse & {
  data?: AccountPagination;
};

export interface Transaction {
  /** profile id */
  profile_id?: string;
  /** address */
  address?: string;
  /** transaction hash */
  tx_hash?: string;
  /** business type. eg. topup/use/~unknown/send/receive/... */
  business_type?: string;
  /**
   * chain id
   * @format int32
   */
  chain_id?: number;
  /** usd price when create transaction */
  token_price?: string;
  /** token symbol not unique */
  token_symbol?: string;
  /** token contract address */
  token_address?: string;
  /** token amount */
  token_amount?: string;
  /** amount */
  amount?: string;
  /** symbol */
  symbol?: string;
  /** symbol */
  gas_symbol?: string;
  /** transaction cost actual gas amount */
  used_gas?: string;
  /** usd price when create transaction */
  gas_usd_price?: string;
  /** transaction status */
  status?: TransactionStatusEnum;
  /** app_id */
  app_id?: string;
  /** operation_id */
  operation_id?: string;
  /** operation_id */
  paymaster_id?: string;
  /**
   * create time
   * @format int64
   */
  created?: number;
  /**
   * modify time
   * @format int64
   */
  modified?: number;
  /** latest price */
  price?: string;
  /** transaction token list */
  tokens?: TransferToken[];
  /** policy id */
  policy_id?: string;
}

export type TransactionsResponse = BaseResponse & {
  data?: Transaction;
};

export interface TransactionPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Transaction[];
}

export type TransactionPaginationResponse = BaseResponse & {
  data?: TransactionPagination;
};

export interface ListTransactionRequest {
  /**
   * @format int32
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  /** osp address default login user address */
  address?: string;
  /** transaction type from/to/all default all */
  transaction_type?: TransactionTypeEnum;
}

export interface ChainPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Chain[];
}

export type ChainPaginationResponse = BaseResponse & {
  data?: ChainPagination;
};

export interface ListChainRequest {
  /** token usage */
  usage?: TokenUsageEnum;
}

export interface Price {
  /** token symbol, eg. BTC */
  symbol?: string;
  /** quote token symbol, eg. USD */
  quote?: string;
  /** the latest price */
  latest?: string;
  /**
   * rise up and fall
   * @format double
   */
  change?: number;
  /**
   * precious
   * @format int32
   */
  decimals?: number;
}

export interface SdkConfig {
  chain?: Chain;
  /** entry point address */
  entry_point_address?: string;
  /** account factory address */
  account_factory_address?: string;
  /** osp router address */
  osp_address?: string;
  /** community nft address */
  community_nft_address?: string;
  /** slot nft community cond address */
  slot_nft_community_cond_address?: string;
  /** fixed fee community cond address */
  fixed_fee_community_cond_address?: string;
  /** erc20 fee join cond address */
  erc20_fee_join_cond_address?: string;
  /** hold token join cond address */
  hold_token_join_cond_address?: string;
  /** native fee join cond address */
  native_fee_join_cond_address?: string;
  /** role access activity cond address */
  role_access_activity_cond_address?: string;
  /** only member referenced cond address */
  only_member_referenced_cond_address?: string;
  /** like reaction */
  like_reaction?: string;
  /** simpleReaction */
  simple_reaction?: string;
  /** vote reaction */
  vote_reaction?: string;
  /** slot nft address */
  slot_nft_address?: string;
  /** store address */
  store_address?: string;
  /** off chain url */
  off_chain_url?: string;
  /** composite view privacy cond */
  composite_view_privacy_cond?: string;
  /** role view privacy cond */
  role_view_privacy_cond?: string;
  /** hold erc721 view privacy cond */
  hold_erc721_view_privacy_cond?: string;
  /** composite activity cond */
  composite_activity_cond?: string;
  /** role activity cond */
  role_activity_cond?: string;
  /** hold erc721 activity cond */
  hold_erc721_activity_cond?: string;
  /** subscription factory address */
  subscription_factory?: string;
  /** paymaster address */
  paymaster_address?: string;
  /** activity json schema url */
  activity_json_schema_url?: string;
}

export type SdkConfigResponse = BaseResponse & {
  data?: SdkConfig;
};

export interface Network {
  /**
   * chain id
   * @format int32
   */
  chain_id?: number;
  /** chain name */
  name?: string;
  /** chain icon */
  icon?: string;
  /** app id */
  app_id?: string;
}

export type NetworkResponse = BaseResponse & {
  data?: Network[];
};

/** theme info */
export interface Theme {
  /** theme id */
  id?: string;
  name?: string;
  community_id?: string;
  app_ids?: string[];
  body?: string;
  /** theme status */
  status?: ThemeStatusEnum;
}

export interface ThemePagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Theme[];
}

export type ThemePaginationResponse = BaseResponse & {
  data?: ThemePagination;
};

/** theme update only name、body、status */
export interface AddThemeRequest {
  name?: string;
  community_id?: string;
  body?: string;
  /** theme status */
  status?: ThemeStatusEnum;
}

/** theme update only name、appIds、body、status */
export interface UpdateThemeRequest {
  name?: string;
  body?: string;
  /** theme status */
  status?: ThemeStatusEnum;
}

export type ThemeResponse = BaseResponse & {
  /** theme info */
  data?: Theme;
};

/** megaphone data info */
export interface Megaphone {
  /**
   * upVote count
   * @format int64
   * @default 0
   */
  upvote_count?: number;
  /**
   * like count
   * @format int64
   * @default 0
   */
  like_count?: number;
  /**
   * comments_count
   * @format int64
   * @default 0
   */
  comment_count?: number;
  /**
   * followers count
   * @format int64
   * @default 0
   */
  follower_count?: number;
  /**
   * exposure count
   * @format int64
   * @default 0
   */
  exposure_count?: number;
  /** reaction id */
  reaction_id?: string;
  /**
   * created
   * @format int64
   */
  created?: number;
  /** megaphone status */
  megaphone_status?: MegaphoneStatusEnum;
  /**
   * megaphone start time
   * @format int64
   */
  start_time?: number;
  /**
   * megaphone end time
   * @format int64
   */
  end_time?: number;
  /** megaphone duration */
  duration?: string;
  /** megaphone cost */
  amount?: string;
  /** megaphone cost currency */
  currency?: string;
  tags?: CommunityTag[];
}

export interface MegaphoneDataRequest {
  /** activity id, 帖子ID */
  activity_id?: string;
}

export type MegaphoneDataResponse = BaseResponse & {
  data?: Megaphone[];
};

export type MegaphoneResponse = BaseResponse & {
  /** megaphone data info */
  data?: Megaphone;
};

export interface MyCommunitySubscription {
  chain_id?: string;
  app_id?: string;
  user_id?: string;
  community_id?: string;
  /**
   * amount
   * @format decimal
   */
  amount?: number;
  /** symbol */
  symbol?: string;
  /** @format int64 */
  start_time?: number;
  /** @format int64 */
  end_time?: number;
  community_gid?: string;
}

export type MyCommunitySubscriptionResponse = BaseResponse & {
  data?: MyCommunitySubscription;
};

export interface CommunitySubscription {
  /** 社区id */
  community_id?: string;
  /** 社区id */
  community_gid?: string;
  /**
   * 订阅总人数
   * @format int64
   */
  subscription_count?: number;
  /**
   * 隐私模式开启状态
   * @format int64
   */
  privacy_status?: number;
  /**
   * 当前有效订阅人数
   * @format int64
   */
  current_subscription_count?: number;
  /** 订阅价格信息 */
  subscribe_price?: CommunitySubscribePrice[];
  /** nft合约地址 */
  nft?: string;
}

export type CommunitySubscriptionResponse = BaseResponse & {
  data?: CommunitySubscription;
};

export interface CommunitySubscribePrice {
  /** token symbol, eg. OwO */
  symbol?: string;
  /** token address */
  token_address?: string;
  /**
   * token decimal
   * @format int32
   */
  decimal?: number;
  /** subscribe price */
  period?: CommunitySubscribePricePeriod[];
}

export interface CommunitySubscribePricePeriod {
  /**
   * price days
   * @format int32
   */
  days?: number;
  /** price amount */
  amount?: string;
}

export type PaymentPlanResponse = BaseResponse & {
  data?: PaymentPlan;
};

export interface Link {
  /**
   * URL for the action
   * @example "https://api.paypal.com/v1/billing/subscriptions/S-9876543210ZYXWVUT"
   */
  href?: string;
  /**
   * Link relation (e.g., self, edit)
   * @example "self"
   */
  rel?: string;
  /**
   * HTTP method for the link
   * @example "GET"
   */
  method?: "GET" | "POST" | "PATCH" | "DELETE";
}

export interface ListPaymentPlanRequest {
  /** Next token */
  next_token?: string;
  /** Limit */
  limit?: number;
  /** Status */
  status?: PaymentPlanStatus[];
  /** Business type */
  business_type?: PayBusinessType;
  /** payment plan ID */
  id?: string;
  /** token usage */
  pay_type?: PayType;
  /** Payment channel */
  pay_channel?: PayChannel;
}

export type PaymentPlanPaginationResponse = BaseResponse & {
  data?: PaymentPlanPagination;
};

export interface PaymentPlanPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int64 */
  total?: number;
  next_token?: string;
  rows?: PaymentPlan[];
}

export interface PaymentPlan {
  /** Payment ID */
  id?: string;
  /** Business ID */
  business_id?: string;
  /** Business type */
  business_type?: PayBusinessType;
  /** Subscription owner ID */
  owner_id?: string;
  /** token usage */
  pay_type?: PayType;
  /** Payment channel */
  pay_channel?: PayChannel;
  /** pay status */
  status?: PaymentPlanStatus;
  /** Subscription sub status */
  sub_status?: string;
  /**
   * Start time
   * @format int64
   */
  start_time?: number;
  /**
   * End time
   * @format int64
   */
  end_time?: number;
  /**
   * Next billing time
   * @format int64
   */
  next_billing_time?: number;
  /**
   * Outstanding balance (arrears), decimal string for precision
   * @format int64
   */
  outstanding_balance?: number;
  /** Payment failure attempts */
  failure_attempts?: number;
  /** Paypal approval links, valid for 3 hours after creation */
  links?: Link[];
  /** member product level */
  product_level?: MemberProductLevelEnum;
  /** product ID */
  product_id?: string;
}

export interface ListPaymentRecordRequest {
  /** Owner ID */
  owner_id?: string;
  /** Next token */
  next_token?: string;
  /** Limit */
  limit?: number;
  /** Status */
  status?: string[];
  /** Business type */
  business_type?: PayBusinessType;
  /** Pay channel */
  pay_channel?: PayChannel;
  business_types?: PayBusinessType[];
}

export type PaymentRecordPaginationResponse = BaseResponse & {
  data?: PaymentRecordPagination;
};

export interface PaymentRecordPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int64 */
  total?: number;
  next_token?: string;
  rows?: PaymentRecord[];
}

export interface PaymentRecord {
  /** Subscriber ID */
  id?: string;
  /** Business type */
  business_type?: PayBusinessType;
  /** Business ID */
  business_id?: string;
  /** Payment ID */
  payment_id?: string;
  /** Subscriber owner ID */
  owner_id?: string;
  /** Payer ID */
  payer?: string;
  /** Amount */
  amount?: number;
  currency?: PaymentCurrency;
  /** Payment channel */
  channel?: PayChannel;
  /**
   * Payment time
   * @format int64
   */
  payment_time?: number;
  /**
   * Charge fee
   * @format double
   */
  charge_fee?: number;
  /** Payment status */
  status?: string;
  /** Product ID */
  product_id?: string;
  /** Detail */
  detail?: string;
  /** Record type */
  record_type?: string;
  /** Refunded record ID */
  refunded_record_id?: string;
  /** Applied offers */
  applied_offers?: string;
}

/** Application context for the transaction. */
export interface PaymentContext {
  /**
   * Brand name displayed on PayPal checkout page.
   * @example "YourBrand"
   */
  brand_name?: string;
  /**
   * Locale for checkout page (e.g., en-US).
   * @example "en-US"
   */
  locale?: string;
  /**
   * Shipping preference for the subscription.
   * @example "NO_SHIPPING"
   */
  shipping_preference?:
    | "NO_SHIPPING"
    | "GET_FROM_FILE"
    | "SET_PROVIDED_ADDRESS";
  /**
   * User action for checkout (SUBSCRIBE_NOW triggers immediate payment).
   * @example "SUBSCRIBE_NOW"
   */
  user_action?: "SUBSCRIBE_NOW" | "CONTINUE";
  /**
   * URL to redirect after successful payment.
   * @format uri
   * @example "https://example.com/success"
   */
  return_url?: string;
  /**
   * URL to redirect after payment cancellation.
   * @format uri
   * @example "https://example.com/cancel"
   */
  cancel_url?: string;
}

export interface PaymentCurrency {
  /** type */
  type?: string;
  /** address */
  address?: string;
  /** currency */
  currency?: string;
  /** chainId */
  chain_id?: string;
  /** ecosystem */
  ecosystem?: string;
}

export interface PaymentCheckRequest {
  /**
   * Product identifier (e.g. expert_subscription); opensocial calls kmember for eligibility and mixture for signing
   * @example "expert_subscription"
   */
  product_id: string;
  /** Payment channel (e.g. IAP) */
  pay_channel: PayChannel;
  /** Application context for the transaction. */
  payment_context?: PaymentContext;
  /** token usage */
  pay_type?: PayType;
}

export type PaymentCheckResponse = BaseResponse & {
  /** payment/check response data; when eligible includes owner_external_ref and productId; when not eligible only offer_details[].eligible=false */
  data?: PaymentCheckResponseData;
};

/** payment/check response data; when eligible includes owner_external_ref and productId; when not eligible only offer_details[].eligible=false */
export interface PaymentCheckResponseData {
  /** Array of offer details (eligible, code, sign) for client to initiate purchase with the store */
  offer_details?: OfferDetail[];
  /** User binding (UUID from encode(ownerId)), to be passed as appAccountToken; used for webhook lookup */
  owner_external_ref?: string;
  /** Product identifier, same as request (e.g. expert_subscription) */
  product_id?: string;
  /** Purchase token for the previous purchase plan, if exist */
  old_purchase_token?: string;
}

/** Single offer detail item */
export interface OfferDetail {
  /** Whether the user is eligible for this offer */
  eligible?: boolean;
  /** Offer code (e.g. FREE_7_TRIAL) */
  code?: string;
  /** Signing info (returned when eligible) */
  sign?: OfferDetailSign;
  /** Payment provider links for this offer (e.g. Stripe Checkout URL) */
  links?: Link[];
}

/** Offer signing info for client to initiate purchase with the store */
export interface OfferDetailSign {
  /** Key ID from App Store Connect */
  key_id?: string;
  /** UUID generated by backend */
  nonce?: string;
  /** Signature computed by backend for store verification */
  signature?: string;
  /**
   * Timestamp in milliseconds
   * @format int64
   */
  timestamp?: number;
}

export interface PaymentConfirmRequest {
  /** Transaction ID from the store (transactionId in JWS or Transaction Info) */
  purchase_token: string;
  /** Payment channel (e.g. IAP); maps to payment_plan.pay_channel for persistence and analytics */
  pay_channel: PayChannel;
  /** Product ID */
  product_id?: string;
}

export type PaymentConfirmResponse = BaseResponse & {
  /** payment/confirm response data */
  data?: PaymentConfirmResponseData;
};

/** payment/confirm response data */
export interface PaymentConfirmResponseData {
  /** result */
  result?: boolean;
}

export interface ListTransactionsRequest {
  /**
   * @format int32
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  /** osp address default login user address */
  address?: string;
  /** operation id */
  operation_id?: string;
  /** business type */
  business_type?: string;
  /** tx hash */
  tx_hash?: string;
  /** user op hash */
  user_op_hash?: string;
  /** app id */
  app_id?: string;
  /** transaction status */
  status?: TransactionStatusEnum;
}

export interface TransferToken {
  /** token amount */
  amount?: string;
  /** address */
  address?: string;
  /** token symbol not unique */
  symbol?: string;
  /**
   * token decimal
   * @format int32
   */
  decimal?: number;
  /** usd price when create transaction */
  price?: string;
  /**
   * 0-Withdraw/1-Deposit
   * @format int32
   */
  direct?: number;
}

export interface ListTransactionStatisticsRequest {
  /**
   * @format int32
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  /** app id */
  app_id?: string;
  /** business id */
  business_id?: string;
  /** business type status */
  business_type?: BusinessType;
}

export type TransactionStatisticsPaginationResponse = BaseResponse & {
  data?: TransactionStatisticsPagination;
};

export interface TransactionStatisticsPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: TransactionStatistics[];
}

export interface TransactionStatistics {
  /** business type status */
  type?: BusinessType;
  /** token amount */
  amount?: string;
  /** address */
  address?: string;
  /** token symbol not unique */
  symbol?: string;
  /**
   * token decimal
   * @format int32
   */
  decimal?: number;
  /**
   * 0-Withdraw/1-Deposit
   * @format int32
   */
  direct?: number;
  /** date */
  date?: string;
  /**
   * transaction count
   * @format int32
   */
  transaction_count?: number;
  /**
   * address count
   * @format int32
   */
  address_count?: number;
}

export type PolicyQuotaDataResponse = BaseResponse & {
  /** user gas quota balance */
  data?: PolicyQuota;
};

/** user gas quota balance */
export interface Quota {
  /** type */
  type?: QuotaBusinessTypeEnum;
  /** max amount per address */
  total?: string;
  /** max amount per address available */
  available?: string;
}

/** user gas quota balance */
export interface PolicyQuota {
  /** policy id */
  policy_id?: string;
  /** token address */
  token_address?: string;
  /** token symbol */
  token_symbol?: string;
  quotas?: Quota[];
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: AppPolicyQuota[];
}

/** quota business type */
export interface PolicyQuotaRequest {
  /**
   * @format int32
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  /** type */
  type?: QuotaBusinessTypeEnum;
}

/** user gas policy quota */
export interface AppPolicyQuota {
  /** policy id */
  policy_id?: string;
  rows?: AppQuota[];
}

/** user gas quota balance */
export interface AppQuota {
  /** type */
  type?: QuotaBusinessTypeEnum;
  /** max amount per address */
  total?: string;
  /** used */
  used?: string;
  /** available */
  available?: string;
  /** token address */
  token_address?: string;
  /** token symbol */
  token_symbol?: string;
}

export interface ListAgentReportRequest {
  /** agent report category */
  category?: AgentReportCategoryEnum;
  /** agent id list */
  agent_ids?: string[];
  /** include id list */
  ids?: string[];
  levels?: AgentReportLevelEnum[];
  /**
   * content language
   * @default "en-US"
   */
  language?: string;
  /** market */
  market?: string;
  /** @default false */
  count_today?: boolean;
  /**
   * If true, only return reports from the last 24 hours
   * @default false
   */
  last_24h?: boolean;
  /**
   * If true, return only reports related to user's favorited assets; if false, return all reports
   * @default true
   */
  asset_only?: boolean;
  enrich?: AgentReportEnrichOption;
  /**
   * page limit
   * @format int32
   * @min 1
   * @max 30
   * @default 20
   */
  limit?: number;
  /** next token for pagination */
  next_token?: string;
}

export interface AgentReportEnrichOption {
  /**
   * If you need to return the token relative information, set this to true.
   * @default false
   */
  enable?: boolean;
  /** @default false */
  with_content?: boolean;
  with_asset?: AssetEnrichOption;
}

export interface AssetEnrichOption {
  /**
   * If you need to return the post relative information, set this to true.
   * @default false
   */
  enable?: boolean;
  /** @default false */
  with_price?: boolean;
}

export type AgentReportPaginationResponse = BaseResponse & {
  data?: AgentReportPagination;
};

export interface AgentReportPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: AgentReport[];
}

/** agent report info */
export interface AgentReport {
  /** report id */
  id?: string;
  /** agent id */
  type?: string;
  /** market */
  market?: string;
  /** asset list */
  assets?: AgentReportAsset[];
  /** category list */
  categories?: AgentReportCategoryEnum[];
  /** agent report content */
  content?: {
    /**
     * Language code
     * @default "en-US"
     */
    language?: string;
    /** agent report description */
    description?: string;
    /** impact description */
    impact?: string;
    /** content */
    content?: string;
    /** agent report thinking */
    thinking?: string;
    /** agent report level (e.g. A+ to A-, or Sell to Stronger Buy) */
    level?: string;
    /** previous level */
    previous_level?: string;
    /** agent report title */
    title?: string;
    /** agent report summary */
    summary?: string;
    /** ranking movements json string for rating pillar report */
    movements?: string;
    /**
     * time timestamp
     * @format int64
     */
    time?: number;
    /** too long didn't read summary */
    tldr?: string;
    /** table of contents */
    toc?: string;
    /**
     * final score
     * @format double
     */
    final_score?: number;
    /** technical analysis signal */
    ta_signal?: TaSignalDTO;
    /** total cumulative value */
    total_cumulative_value?: string;
    /** total cumulative PnL */
    total_cumulative_pnl?: string;
    /** total cumulative PnL percent */
    total_cumulative_pnl_percent?: string;
    /** today cumulative PnL */
    today_cumulative_pnl?: string;
    /** today cumulative PnL percent */
    today_cumulative_pnl_percent?: string;
    /** total max drawdown */
    total_max_drawdown?: string;
    /** today PnL */
    today_pnl?: string;
    /** Sharpe ratio */
    sharpe_ratio?: string;
  };
  agent_id?: string;
  /** agent report level */
  level?: AgentReportLevelEnum;
  /** source id list */
  source_ids?: string[];
  /** source agent id list */
  source_agent_ids?: string[];
  /** source link */
  source_link?: string;
  /**
   * created timestamp
   * @format int64
   */
  created?: number;
}

/** asset info */
export interface AgentReportAsset {
  /** asset id */
  id?: string;
  /** asset symbol */
  symbol?: string;
  /** logo */
  logo?: string;
  /** asset type */
  type?: string;
  /** coin price change 24h */
  price_change_24h?: number;
  /** The current price of the stock */
  current_price?: number;
  /** The previous close price of the stock */
  previous_close?: number;
  /** stock short name */
  short_name?: string;
  /** stock symbol company name */
  company_name?: string;
}

/** TA signal DTO */
export interface TaSignalDTO {
  /** List of TA indicator signals */
  ta_signals?: TAIndicatorDTO[];
  /**
   * Trend analysis time timestamp
   * @format int64
   */
  trend_analysis_time?: number;
  /** Trend analysis */
  trend_analysis?: string;
  /**
   * Trend analysis change percent
   * @format double
   */
  trend_analysis_change_percent?: number;
  /** Last SMA values (Map<String, BigDecimal>) */
  last_sma?: Record<string, number>;
  /**
   * Last Stochastic K value
   * @format double
   */
  last_stochastic_k?: number;
  /**
   * Last MACD value
   * @format double
   */
  last_macd?: number;
  /**
   * Price
   * @format double
   */
  price?: number;
  /**
   * 24h price change percent
   * @format double
   */
  change_price_percent_24?: number;
  /** Overall sentiment (Bearish / Bullish / Neutral) */
  sentiment?: string;
}

/** TA indicator DTO */
export interface TAIndicatorDTO {
  /** Indicator name (e.g. MA/RSI/MACD/Stochastic) */
  indicator?: string;
  /** Signal description corresponding to the indicator */
  signal?: string;
  /** Indicator value (as string) */
  value?: string;
  /** Market sentiment */
  sentiment?: string;
  /** Original signal value (for frontend score judgment, e.g. "1" / "-1" / "0") */
  signal_value?: string;
}

export interface App {
  /** app id */
  id?: string;
  /** app name */
  name?: string;
  /** app description */
  description?: string;
  /** app price */
  price?: string;
  /** apps token address */
  token_address?: string;
  /** icon */
  image?: string;
  /** images or video,etc */
  medias?: Media[];
  /** Expansions, new features and historical versions */
  ext?: AppExt[];
  /** app category */
  category?: AppCategoryEnum;
  /** schema id */
  data_schema_id?: string;
  /** gitlab path */
  project_path?: string;
  /** main */
  main?: string;
  /** ui */
  ui?: string;
  /** network_access */
  network_access?: string;
  /** abi */
  abi?: string;
  /** charge_fee */
  charge_fee?: string;
  /** osp_proxy_address */
  proxy_address?: string;
  /** capabilities */
  capabilities?: object[];
  /** apps info */
  schema?: {
    /** main */
    main?: string;
    /** ui */
    ui?: string;
    /** network_access */
    network_access?: string;
    /** abis */
    abis?: string;
    /** charge_fee */
    charge_fee?: string;
    /** osp_proxy_address */
    proxy_address?: string;
    /** capabilities */
    capabilities?: object[];
    /** extension_data */
    extension_data?: string;
    /** powered */
    powered?: string;
  };
}

export interface AppPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: App[];
}

export type AppPaginationResponse = BaseResponse & {
  data?: AppPagination;
};

/** query apps */
export interface ListAppRequest {
  /** @maxItems 20 */
  ids?: string[];
  community_id?: string;
  /** @default false */
  owned?: boolean;
  /** apps category */
  category?: AppCategoryEnum;
  /**
   * @min 1
   * @max 20
   */
  limit?: number;
  next_token?: string;
  /** POST 、COMMENT */
  capability?: string;
  /** story contract address */
  proxy_address?: string;
}

/** apps ext */
export interface AppExt {
  /** version number */
  version?: string;
  /** version update time */
  time?: string;
  /** version update description */
  description?: string;
}

export type AppCheckResponse = BaseResponse & {
  /** @default true */
  data?: boolean;
};

/** apps data info */
export interface AddAppDataRequest {
  /** a string of the json data that needs to be verified in json schema */
  data?: string;
  /** community id */
  community_id?: string;
}

/** apps data info */
export interface UpdateAppDataRequest {
  /** a string of the json data that needs to be verified in json schema */
  data?: string;
  /** status */
  status?: AppDataStatusEnum;
}

/** apps data info */
export interface AppData {
  /** dataId */
  id?: string;
  /** app id */
  app_id?: string;
  /** a string of the json data that needs to be verified in json schema */
  data?: string;
  /** the user id of data publisher */
  user_id?: string;
  /** the user gid of data publisher */
  user_gid?: string;
  /** community id */
  community_id?: string;
  /** community gid */
  community_gid?: string;
  /** status */
  status?: AppDataStatusEnum;
}

export type AppDataGroup = AppData[];

export type AppDataResponse = BaseResponse & {
  /** apps data info */
  data?: AppData;
};

export type AppDataGroupResponse = BaseResponse & {
  data?: AppDataGroup;
};

/** postDoc */
export interface PostDoc {
  /** id */
  id?: string;
  /**
   * time of create
   * @format int64
   */
  created?: number;
  /** title */
  title?: string;
  /** text */
  text?: string;
  /** @format int64 */
  verb?: number;
  /** @format int64 */
  sub_verb?: number;
  user_id?: string;
  community_id?: string;
  user_gid?: string;
  community_gid?: string;
  tag?: string;
  /** @format int32 */
  status?: number;
  medias?: Media[];
  /** @format int64 */
  share_count?: number;
  /** @format int64 */
  like_count?: number;
  /** @format int64 */
  comment_count?: number;
  /** @format int64 */
  reply_count?: number;
  /** @format int64 */
  favorite_count?: number;
  /** @format int64 */
  view_count?: number;
  /** @format int64 */
  megaphone_count?: number;
  content?: string;
  urls?: string;
  profile_id?: string;
  hashtags?: string[];
  content_id?: string;
  /** userDoc */
  user?: UserDoc;
  /** high light */
  highlight?: Record<string, string[]>;
  /** @format int64 */
  privacy?: number;
}

/** userDoc */
export interface UserDoc {
  /** id */
  id?: string;
  /** gid */
  gid?: string;
  /**
   * time of create
   * @format int64
   */
  created?: number;
  /** intro */
  intro?: string;
  /** nick_name */
  nick_name?: string;
  /** unique_name */
  unique_name?: string;
  /** @format int32 */
  type?: number;
  /** avatar */
  avatar?: string;
  /** region */
  region?: string;
  /** kol_intro */
  kol_intro?: string;
  /** kol_background_url */
  kol_background_url?: string;
  /**
   * following_count
   * @format int32
   */
  following_count?: number;
  /**
   * follower_count
   * @format int64
   */
  follower_count?: number;
  /**
   * favorite_count
   * @format int32
   */
  favorite_count?: number;
  /**
   * post_count
   * @format int32
   */
  post_count?: number;
  /**
   * post_count
   * @format int32
   */
  join_count?: number;
  owner_id?: string;
  profile_id?: string;
  follow_nft?: string;
  /** Deprecated when osp_address be use */
  address?: string;
  osp_address?: string;
  joining_community?: JoiningCommunity[];
  /** high light */
  highlight?: Record<string, string[]>;
}

/** userDoc */
export interface CommunityDoc {
  /** id */
  id?: string;
  /** gid */
  gid?: string;
  /**
   * time of create
   * @format int64
   */
  created?: number;
  /** chain_id */
  chain_id?: string;
  /** bind_app_id */
  bind_app_id?: string;
  /** display_name */
  display_name?: string;
  /** desc */
  desc?: string;
  /** unique_name */
  unique_name?: string;
  /** banner */
  banner?: string;
  /** user_id */
  user_id?: string;
  /** user_gid */
  user_gid?: string;
  /** logo */
  logo?: string;
  /** join_nft */
  join_nft?: string;
  /** tags */
  tags?: string;
  address?: string;
  owner_id?: string;
  profile_id?: string;
  /** activity_tags */
  activity_tags?: string;
  /**
   * view_count
   * @format int32
   */
  view_count?: number;
  /**
   * activity_count
   * @format int32
   */
  activity_count?: number;
  /**
   * member_count
   * @format int64
   */
  member_count?: number;
  /** high light */
  highlight?: Record<string, string[]>;
  /** @format int64 */
  dapp_type?: number;
  /** userDoc */
  user?: UserDoc;
}

/** hashtagDTO */
export interface HashtagDoc {
  /** hashtag */
  hashtag?: string;
  /** high light */
  highlight?: Record<string, string[]>;
}

/** OpenPostDoc */
export interface OpenPostDoc {
  /** businessId */
  businessId?: string;
  /** platform */
  platform?: string;
  author?: object;
  property?: object;
}

export interface DocPagination {
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int64
   */
  totalCount?: number;
  /**
   * 翻页offset
   * @format int32
   */
  offset?: number;
  rows?: (UserDoc | PostDoc | CommunityDoc | HashtagDoc | OpenPostDoc)[];
}

export interface SearchDocRequest {
  /** search keyWords */
  keyWords?: string;
  /** sort */
  sort?: string[];
  /** zone */
  zone?: string;
  /**
   * nextToken for pagination
   * @format int32
   */
  page?: number;
  /**
   * limit for pagination
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * searchType
   * @format int32
   */
  search_type?: number;
  /** activity status */
  type?: SearchTypeEnum;
  /** search params for flat */
  params?: Record<string, any>;
}

export type DocPaginationResponse = BaseResponse & {
  data?: DocPagination;
};

/** joiningCommunity */
export interface JoiningCommunity {
  /** community id */
  community_id?: string;
  /** community gid */
  community_gid?: string;
  /** relation role enum */
  role?: RelationRoleEnum;
  /** join time */
  join_time?: string;
  /** relation status enum */
  status?: RelationStatusEnum;
}

export interface SearchMultipleDocRequest {
  /** search keyWords */
  keywords?: string;
  /** zone */
  zone?: string;
  /**
   * nextToken for pagination
   * @format int32
   */
  page?: number;
  /**
   * limit for pagination
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** searchType List */
  types?: SearchTypeEnum[];
  /** sort map */
  sort?: Record<string, any>;
  /** search params for flat */
  params?: Record<string, any>;
  /** Is it an exact term */
  exact?: boolean;
}

export type DocMultiplePaginationResponse = BaseResponse & {
  data?: Record<string, DocPagination>;
};

export interface DocMultipleData {
  /** doc multiple */
  multiple_data?: Record<string, DocPagination>;
}

export interface SearchActivityRequest {
  /** search keywords */
  keywords?: string;
  /**
   * nextToken for pagination
   * @format int32
   */
  page?: number;
  /**
   * limit for pagination
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** sort */
  sort?: string[];
  enrich?: FeedEnrichOption;
  /** search params for flat */
  params?: Record<string, any>;
  /** Is it an exact term */
  exact?: boolean;
}

export type PostFeedPaginationResponse = BaseResponse & {
  data?: PostFeedPagination;
};

export interface PostFeedPagination {
  /**
   * Number of per request
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * The total number of pages returned. By default, the total number of pages is not queried. 0 is returned
   * @format int64
   */
  totalCount?: number;
  /**
   * position
   * @format int32
   */
  offset?: number;
  rows?: (UserDoc | PostDoc | CommunityDoc | HashtagDoc | OpenPostDoc)[];
  feeds?: Feed[];
}

export interface SearchGroupDocRequest {
  /** group_key */
  group_key?: string;
  /**
   * top_count for group
   * @format int32
   * @min 1
   * @max 20
   */
  top_count?: number;
  /** activity status */
  type?: SearchTypeEnum;
  /** query params for flat */
  query_params?: Record<string, any>;
  /** group params for flat */
  group_params?: Record<string, any>;
}

/** groupDoc */
export interface GroupDoc {
  /** group key */
  key?: string;
  /**
   * group count
   * @format int64
   */
  count?: number;
  object?: object;
}

export type DocGroupPaginationResponse = BaseResponse & {
  data?: DocGroupPagination;
};

export interface DocGroupPagination {
  rows?: GroupDoc[];
}

export interface SearchFront {
  fundraiser?: SearchFrontItem[];
  project?: SearchFrontItem[];
  ecosystem?: SearchFrontItem[];
}

export interface SearchFrontItem {
  /** id */
  name?: string;
  /** owner id */
  logo?: string;
  label?: string[];
  /** rounds */
  rounds?: string;
  /** published_time */
  published_time?: string;
  /** amount */
  amount?: string;
  /** description */
  description?: string;
}

export type SearchFrontResponse = BaseResponse & {
  data?: SearchFront;
};

/** preset question */
export interface AIQuestion {
  agent_id?: string;
  scopes?: string[];
  icon?: string;
  multi_language_contents?: AIQuestionMultiLanguageContent[];
  type?: string;
}

export interface AIQuestionMultiLanguageContent {
  language?: string;
  title?: string;
  display_title?: string;
  description?: string;
  answer?: string;
  default_answer?: string;
}

export interface AIQuestionPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** next token */
  next_token?: string;
  rows?: AIQuestion[];
}

export type AIQuestionPaginationResponse = BaseResponse & {
  data?: AIQuestionPagination;
};

export interface AIQuestionRequest {
  /**
   * page limit
   * @format int32
   * @default 5
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  /** agent id */
  agent_id?: string;
  /** is random question */
  random?: boolean;
  /** scope */
  scope?: string;
  types?: ("token" | "ecosystem" | "general")[];
  languages?: string[];
}

export interface AIFeed {
  /** id */
  view_id?: string;
  /** owner id */
  owner_id?: string;
  /** feed source */
  source?: AIFeedSourceEnum;
  /** title */
  title?: string;
  /** content */
  content?: string;
  medias?: AIFeedMedia[];
  urls?: AIFeedUrl[];
  /** author name */
  author_name?: string;
  /** author avatars */
  author_avatar?: string;
  /**
   * activity time
   * @format int64
   */
  activity_time?: number;
  /**
   * post media convert status 0 ing 1 end
   * @format int64
   */
  media_status?: number;
  /**
   * 1-privacy post
   * @format int64
   */
  privacy?: number;
  /** community info */
  community?: AIFeedCommunity;
}

export interface AIFeedPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** next token */
  next_token?: string;
  rows?: AIFeed[];
}

export type AIFeedPaginationResponse = BaseResponse & {
  data?: AIFeedPagination;
};

export interface AIFeedRequest {
  /**
   * page limit
   * @format int32
   * @default 5
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
}

export interface AIFeedMedia {
  /** id for resource */
  id?: string;
  /** media url */
  display_url?: string;
  /** media url */
  media_url?: string;
  /** http url */
  media_url_https?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  type?: string;
  /** native/twitter/giphy */
  source?: string;
  /** link */
  link?: string;
  /** url */
  url?: string;
  /** json format sizes */
  sizes?: string;
  /** extra cover url */
  extra?: string;
}

export interface AIFeedUrl {
  /** url */
  url?: string;
  /** og or twitter title */
  title?: string;
  /** og or twitter description */
  description?: string;
  /** og or twitter image */
  image?: string;
  /** embed html */
  html?: string;
}

/** portrayal info */
export interface UserPortrait {
  /** owner id */
  owner_id?: string;
  /** eoa_address */
  eoa_address?: string;
  /** summary */
  summary?: string;
  /**
   * status
   * @format int32
   */
  status?: number;
  /** handle */
  keywords?: string[];
}

export type UserPortraitResponse = BaseResponse & {
  /** portrayal info */
  data?: UserPortrait;
};

/** community info */
export interface AIFeedCommunity {
  /** chain id */
  chain_id?: string;
  /** id */
  id?: string;
  /** unique name */
  handle?: string;
  /** bind app id */
  bind_app_id?: string;
  /** view privacy post condition */
  view_privacy_condition?: string;
  /**
   * joining_status 0 Not joined, 1 Joined, 2 Blacklisted
   * @format int64
   */
  joining_status?: number;
  /**
   * subscribe_status 0 not subscribed, 1 subscribed
   * @format int64
   */
  subscribe_status?: number;
  /** join tribe role */
  joining_role?: RelationRoleEnum;
}

/** news info */
export interface AINews {
  serial?: string;
  news?: {
    url?: string;
    title?: string;
  }[];
  related_questions?: string[];
}

export type AINewsResponse = BaseResponse & {
  /** news info */
  data?: AINews;
};

export type TranslationResponse = BaseResponse & {
  /** Feed Translation */
  data?: Translation;
};

/** Feed Translation */
export interface Translation {
  title?: string;
  content?: string;
}

export interface AdminBaseResponse {
  /** sub code */
  code?: number;
  /** information for the response */
  msgKey?: string;
  success?: boolean;
}

export interface RecommendCommunity {
  chain_id?: string;
  handle?: string;
  app_id?: string;
  community_id?: string;
  /** @format int32 */
  member_count?: number;
  logo?: string;
  banner?: string;
  /** owner address */
  owner?: string;
  /** owner avatar */
  owner_avatar?: string;
  /** owner handle */
  owner_handle?: string;
  /** @format int32 */
  sort?: number;
  /** @format int64 */
  start_time?: number;
  /** @format int64 */
  end_time?: number;
  reason?: string;
  tag?: string;
}

export interface AddRecommendCommunity {
  chain_id?: string;
  handle?: string;
  /** @format int32 */
  sort?: number;
  /** @format int64 */
  end_time?: number;
  reason?: string;
  banner?: string;
  /**
   * 0=banner or 1=forYou or 2=popular or 3=leaderboard
   * @format int32
   */
  type?: number;
  tag?: string;
}

export interface DeleteRecommendCommunity {
  chain_id?: string;
  handle?: string;
  /**
   * 0=banner or 1=forYou
   * @format int32
   */
  type?: number;
  tag?: string;
}

export type RecommendCommunityOperateResponse = BaseResponse & {
  obj: boolean;
};

export interface RecommendCommunityPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total size
   * @format int32
   */
  total?: number;
  /** next page start position */
  next_token?: string;
  rows?: RecommendCommunity[];
}

export interface RecommendCommunityPaginationRequest {
  /**
   * 0=banner or 1=forYou  or 2=popular or 3=leaderboard
   * @format int32
   */
  type?: number;
  tag?: string;
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 50
   */
  limit?: number;
  /** token */
  next_token?: string;
}

export type RecommendCommunityPaginationResponse = BaseResponse & {
  obj: RecommendCommunityPagination;
};

export interface RecommendUser {
  chain_id?: string;
  handle?: string;
  /** @format int64 */
  end_time?: number;
  /** @format int64 */
  start_time?: number;
  /** @format int32 */
  sort?: number;
  tag?: string;
  /**
   * 0= pin or 1=popular
   * @format int32
   */
  type?: number;
  /** @format int64 */
  created?: number;
}

/** recommend user */
export interface AddRecommendUser {
  chain_id?: string;
  handle?: string;
  /** @format int32 */
  sort?: number;
  /** @format int64 */
  end_time?: number;
  tag?: string;
  /**
   * 0=global hot pin user or 1=popular
   * @format int32
   */
  type?: number;
}

export interface DeleteRecommendUser {
  chain_id?: string;
  handle?: string;
  /**
   * 0=global hot pin user or 1=popular
   * @format int32
   */
  type?: number;
  tag?: string;
}

export type RecommendUserOperateResponse = BaseResponse & {
  obj: boolean;
};

export interface RecommendUserPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total size
   * @format int32
   */
  total?: number;
  /** next page start position */
  next_token?: string;
  rows?: RecommendUser[];
}

export interface RecommendUserPaginationRequest {
  /**
   * 0=global hot pin user or 1=popular
   * @format int32
   */
  type?: number;
  tag?: string;
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 50
   */
  limit?: number;
  /** token */
  next_token?: string;
  chain_id?: string;
}

export type RecommendUserPaginationResponse = BaseResponse & {
  obj: RecommendUserPagination;
};

export interface AddAssetConfigRequest {
  name?: string;
  chain_id?: string;
  network?: string;
  type?: string;
  address?: string;
  /** @format int32 */
  decimal?: number;
  channel?: string;
}

export interface AddBadgeRequest {
  chain_id?: string;
  address?: string;
  name?: string;
  token_id?: string;
  /** @format int32 */
  level?: number;
  title?: string;
  background?: string;
  image?: string;
  unclaim_image?: string;
  icon?: string;
  series_id?: string;
  category?: string;
  conditions?: Condition[];
  /** badge strategy */
  strategy?: StrategyEnum;
  description?: string;
  assets_id?: string;
  /**
   * 0=normal or 1=delete
   * @format int32
   */
  status?: number;
}

export interface AddBadgeSeriesRequest {
  chain_id?: string;
  group?: string;
  name?: string;
  logo?: string;
  description?: string;
  /** @format int32 */
  sort?: number;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modify?: number;
}

export interface AssetConfig {
  name?: string;
  chain_id?: string;
  network?: string;
  type?: string;
  address?: string;
  channel?: string;
  /** @format int32 */
  decimal?: number;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modify?: number;
}

export type AssetConfigOperateResponse = BaseResponse & {
  obj: boolean;
};

export interface AssetConfigPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total size
   * @format int32
   */
  total?: number;
  /** next page start position */
  next_token?: string;
  rows?: AssetConfig[];
}

export interface AdminListAssetConfigRequest {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 50
   */
  limit?: number;
  /** token */
  next_token?: string;
}

export type AssetConfigPaginationResponse = BaseResponse & {
  obj: AssetConfigPagination;
};

export interface AdminBadge {
  chain_id?: string;
  address?: string;
  name?: string;
  token_id?: string;
  /** @format int32 */
  level?: number;
  title?: string;
  background?: string;
  image?: string;
  unclaim_image?: string;
  icon?: string;
  series_id?: string;
  category?: string;
  conditions?: Condition[];
  /** badge strategy */
  strategy?: StrategyEnum;
  description?: string;
  assets_id?: string;
  /**
   * 0=normal or 1=delete
   * @format int32
   */
  status?: number;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modify?: number;
}

export type BadgeOperateResponse = BaseResponse & {
  obj: boolean;
};

export interface BadgePagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total size
   * @format int32
   */
  total?: number;
  /** next page start position */
  next_token?: string;
  rows?: AdminBadge[];
}

export interface AdminListBadgeRequest {
  /**
   * 0=normal or 1=delete
   * @format int32
   */
  status?: number;
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 50
   */
  limit?: number;
  /** token */
  next_token?: string;
}

export type BadgePaginationResponse = BaseResponse & {
  obj: BadgePagination;
};

export interface BadgeSeries {
  series?: string;
  chain_id?: string;
  group?: string;
  name?: string;
  logo?: string;
  description?: string;
  /** @format int32 */
  sort?: number;
  /**
   * 0=normal or 1=delete
   * @format int32
   */
  status?: number;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modify?: number;
}

export type BadgeSeriesOperateResponse = BaseResponse & {
  obj: boolean;
};

export interface BadgeSeriesPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total size
   * @format int32
   */
  total?: number;
  /** next page start position */
  next_token?: string;
  rows?: BadgeSeries[];
}

export interface AdminListBadgeSeriesRequest {
  /**
   * 0=normal or 1=delete
   * @format int32
   */
  status?: number;
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 50
   */
  limit?: number;
  /** token */
  next_token?: string;
}

export type BadgeSeriesPaginationResponse = BaseResponse & {
  obj: BadgeSeriesPagination;
};

export interface Condition {
  name?: string;
  asset_id?: string;
  /** condition type */
  condition_type?: ConditionTypeEnum;
  /** condition calculate type */
  calculate_type?: CalculateTypeEnum;
  /** @format int64 */
  required_value?: number;
  /** @format int64 */
  required_score?: number;
  /** condition operator */
  operator?: OperatorEnum;
  /** @format int64 */
  achieved_value?: number;
  /** @format int64 */
  achieved_score?: number;
}

export interface DeleteAssetConfigRequest {
  chain_id?: string;
  id?: string;
}

export interface DeleteBadgeRequest {
  chain_id?: string;
  token_id?: string;
  address?: string;
}

export interface DeleteBadgeSeriesRequest {
  chain_id?: string;
  id?: string;
}

export interface UpdateAssetConfigRequest {
  id?: string;
  name?: string;
  chain_id?: string;
  network?: string;
  type?: string;
  address?: string;
  /** @format int32 */
  decimal?: number;
  channel?: string;
}

export interface UpdateBadgeRequest {
  chain_id?: string;
  address?: string;
  name?: string;
  token_id?: string;
  /** @format int32 */
  level?: number;
  title?: string;
  background?: string;
  image?: string;
  unclaim_image?: string;
  icon?: string;
  series_id?: string;
  category?: string;
  conditions?: Condition[];
  /** badge strategy */
  strategy?: StrategyEnum;
  description?: string;
  assets_id?: string;
  /**
   * 0=normal or 1=delete
   * @format int32
   */
  status?: number;
}

export interface UpdateBadgeSeriesRequest {
  series?: string;
  chain_id?: string;
  group?: string;
  name?: string;
  logo?: string;
  description?: string;
  /** @format int32 */
  sort?: number;
  /**
   * 0=normal or 1=delete
   * @format int32
   */
  status?: number;
}

export interface AddAIQuestionRequest {
  questions?: AIQuestion[];
}

export type AddAIQuestionResponse = BaseResponse & {
  obj: boolean;
};

/** Reward product info for member rewards */
export interface RewardProductInfo {
  /** Identity type enum (EMAIL/X_ID/EOA_ADDRESS/OWNER_ID/X_HANDLE) */
  identity_type: IdentityTypeEnum;
  /** Identity value corresponding to identity_type */
  identity_id: string;
  /** Reward product ID */
  reward_product: string;
  /** Payment ID (optional, for deduplication) */
  pay_id?: string;
}

/** Member reward whitelist entry */
export interface MemberRewardWhitelist {
  /** Identity type enum (EMAIL/X_ID/EOA_ADDRESS/OWNER_ID/X_HANDLE) */
  identity_type: IdentityTypeEnum;
  /** Identity value corresponding to identity_type */
  identity_id: string;
  /** Product ID */
  product_id: string;
  /**
   * Create timestamp (auto generated when adding)
   * @format int64
   */
  create_time?: number;
  /** Source */
  source?: string;
}

export type MemberRewardWhitelistResponse = BaseResponse & {
  data?: MemberRewardWhitelist[];
};

export interface KolFollowRequest {
  /**
   * page limit
   * @format int32
   * @default 5
   */
  limit?: number;
  /**
   * page size
   * @format int32
   * @default 5
   */
  page_size?: number;
}

export type KolFollowPaginationResponse = BaseResponse & {
  data?: KolFollowPagination;
};

export interface KolFollowPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** next token */
  next_token?: string;
  rows?: KolFollow[];
}

export interface KolFollow {
  /** type mention,follow */
  type?: string;
  /**
   * time
   * @format int64
   */
  time?: number;
  /** people id */
  people_id?: string;
  /** name */
  name?: string;
  /** screen name */
  screenName?: string;
  /** profile image url https */
  profileImageUrlHttps?: string;
  /**
   * related post count
   * @format int64
   */
  relatedPostCount?: number;
  /** token handle */
  token_handle?: string;
  /** token image */
  token_image?: string;
  /** post id */
  post_id?: string;
}

export interface Fac {
  /**
   * amount
   * @format int64
   */
  amount?: number;
  /**
   * project id
   * @format int32
   */
  project_id?: number;
  /** published time */
  published_time?: string;
  /** name */
  name?: string;
  /** Logo */
  logo?: string;
  /** rounds */
  rounds?: string;
  /** invests */
  invests?: Investor[];
  social_media?: SocialMediaAddress;
  /** token symbol */
  token_symbol?: string;
  contract_address?: {
    /** id */
    id?: string;
    /** token address */
    address?: string;
    /** platform */
    platform?: string;
  }[];
  /** @format int64 */
  valuation?: number;
  project?: TopProject;
}

export interface Investor {
  /** name */
  name?: string;
  /** Logo */
  logo?: string;
}

export interface FacPagination {
  /**
   * limit
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total default 0
   * @format int32
   */
  total?: number;
  /** next token */
  next_token?: string;
  rows?: Fac[];
}

export type FacPaginationResponse = BaseResponse & {
  data?: FacPagination;
};

export interface TopProject {
  /**
   * eval
   * @format double
   */
  eval?: number;
  /** eval_change_cycle */
  eval_change_cycle?: number;
  /**
   * project id
   * @format int32
   */
  project_id?: number;
  /** one liner */
  one_liner?: string;
  /** Logo */
  logo?: string;
  /**
   * rank
   * @format int32
   */
  rank?: number;
  /** root data url */
  root_data_url?: string;
  /** token symbol */
  token_symbol?: string;
  /** project name */
  project_name?: string;
  /** tags */
  tags?: string[];
  contract_address?: {
    /** id */
    id?: string;
    /** token address */
    address?: string;
    /** platform */
    platform?: string;
  }[];
  /** white list favorite */
  favorite?: number;
  /** description */
  description?: string;
}

export interface TopProjectPagination {
  /**
   * limit
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total default 0
   * @format int32
   */
  total?: number;
  /** next token */
  next_token?: string;
  rows?: TopProject[];
}

export type TopProjectPaginationResponse = BaseResponse & {
  data?: TopProjectPagination;
};

export type OpenDataTokenPaginationResponse = BaseResponse & {
  data?: OpenDataTokenPagination;
};

export interface OpenDataTokenPagination {
  /** @format int32 */
  total?: number;
  rows?: OpenDataToken[];
}

export interface OpenDataToken {
  id?: string;
  chain_image_url?: string;
  name?: string;
  symbol?: string;
  /** @format int64 */
  token_created_at?: number;
  market_cap?: string;
  liquidity?: string;
  fdv?: string;
  socials?: {
    image_url?: string;
    website?: string;
    twitter?: string;
    telegram?: string;
  };
  engaged_influencers?: {
    nick_name?: string;
    handle?: string;
    avatar?: string;
    related_post_count?: number;
    operations?: {
      /** follow/mention */
      type?: string;
      /** @format int64 */
      operate_time?: number;
    }[];
  }[];
  pools?: TokenPool[];
  trade?: TokenPoolTrade;
  favorite?: boolean;
  sparkline?: Kline[];
  summary?: string;
  /** 360 rating score */
  latest_rating?: Rating;
}

export interface TokenPool {
  pool_address?: string;
  trade?: TokenPoolTrade;
  quote_symbol?: string;
  dex_image_url?: string;
  chain?: string;
}

export interface TokenPoolTrade {
  vol_5m?: string;
  vol_1h?: string;
  vol_6h?: string;
  vol_24h?: string;
  smart_buy_vol_5m?: string;
  smart_buy_vol_1h?: string;
  smart_buy_vol_6h?: string;
  smart_buy_vol_24h?: string;
  smart_sell_vol_5m?: string;
  smart_sell_vol_1h?: string;
  smart_sell_vol_6h?: string;
  smart_sell_vol_24h?: string;
  price?: string;
  price_change_5m?: string;
  price_change_1h?: string;
  price_change_6h?: string;
  price_change_24h?: string;
  price_change_7d?: string;
  vol_change_5m?: string;
  vol_change_pre_5m?: string;
  vol_change_1h?: string;
  vol_change_pre_1h?: string;
  turnover_rate?: string;
  price_usdt?: string;
  smart_buy_vol_5m_usdt?: string;
  smart_buy_vol_1h_usdt?: string;
  smart_buy_vol_6h_usdt?: string;
  smart_buy_vol_24h_usdt?: string;
  smart_sell_vol_5m_usdt?: string;
  smart_sell_vol_1h_usdt?: string;
  smart_sell_vol_6h_usdt?: string;
  smart_sell_vol_24h_usdt?: string;
  /**
   * vol_24h_usdt
   * @example "0.000000000000000000"
   */
  vol_24h_usdt?: string;
  txns_5m?: string;
  txns_1h?: string;
  txns_6h?: string;
  txns_24h?: string;
}

export interface OpenDataTokenReactionRequest {
  chain_id?: string;
  address?: string;
}

export type OpenDataTokenReactionResponse = BaseResponse & {
  data?: {
    result?: boolean;
  };
};

export interface SocialMediaAddress {
  /** website */
  website?: string;
  /** gitbook */
  gitbook?: string;
  /** x */
  x?: string;
  /** string */
  linkedin?: string;
  /** string */
  medium?: string;
}

export interface KlineRequest {
  /** symbol list */
  symbol?: string[];
}

export type KlineResponse = BaseResponse & {
  data?: object;
};

export interface Kline {
  /**
   * timestamp
   * @format int64
   */
  timestamp?: number;
  /** price */
  price?: string;
}

/** 360 rating score */
export interface Rating {
  /** 360 rating level map */
  level?: Record<string, string>;
  /** 360 rating score map */
  score?: Record<string, number>;
  /** rating indicator values map */
  indicator_values?: Record<string, number>;
  /** pillar scores grouped by pillar name */
  pillar_scores?: Record<
    string,
    {
      /** pillar score */
      score?: number;
      /** pillar score description */
      description?: string;
    }
  >;
  /** ranking data grouped by theme */
  pillar_rankings?: {
    /** theme id */
    theme_id?: string;
    /**
     * asset ranking in the theme
     * @format int64
     */
    ranking?: number;
    /**
     * total number of assets participating in the theme ranking
     * @format int64
     */
    ranking_count?: number;
    /** pillar rankings grouped by pillar name, key is pillar dimension, value is ranking */
    pillars?: Record<string, number>;
  }[];
  /** 360 report title */
  title?: string;
  /** 360 report summary */
  summary?: string;
  /** 360 report tldr */
  tldr?: string;
  /** 360 report table of contents */
  toc?: string[];
  /**
   * 360 report time
   * @format int64
   */
  report_time?: number;
}

export type OpenDataTokenPoolPaginationResponse = BaseResponse & {
  data?: OpenDataTokenPoolPagination;
};

export interface OpenDataTokenPoolPagination {
  /** @format int32 */
  total?: number;
  rows?: TokenPool[];
}

/** query communities */
export interface PlatformBindChatGroupRequest {
  /** community id */
  community_id: string;
  /** channel name */
  channel: ChatGroupChannel;
  /** public or private */
  type: ChatGroupType;
  /** invite link */
  invite_link: string;
}

/** unbind chat group from communities */
export interface PlatformUnbindChatGroupRequest {
  /** community id */
  community_id: string;
  /** channel name */
  channel: ChatGroupChannel;
  /** group id */
  group_id: string;
}

export type BindChatGroupResponse = BaseResponse & {
  /** community info */
  data?: Community;
};

export type PopularityResponse = BaseResponse & {
  /** popularity */
  data?: Popularity;
};

/** popularity */
export interface Popularity {
  chain?: Chain;
  /** reaction kind */
  type?: PopularityEnum;
  /** @format int64 */
  count?: number;
}

export interface PopularityPagination {
  rows?: Popularity[];
}

export type PopularityPaginationResponse = BaseResponse & {
  data?: PopularityPagination;
};

export interface Bind {
  /** owner id */
  owner_id?: string;
  /** platform id */
  platform_id?: string;
  /** platform */
  platform?: BindTypeEnum;
  /** name */
  name?: string;
  /**
   * bind time
   * @format int64
   */
  bind_time?: number;
  /** eoa address */
  eoa_address?: string;
  /** true already occupied */
  occupied?: boolean;
  /** profile */
  profile?: ProfileDTO[];
  /** is sync to osp */
  sync_to_osp?: boolean;
  /** is sync to platform */
  sync_to_platform?: boolean;
  /** is have credential */
  have_credential?: boolean;
  space_ids?: string[];
  /** platform smart followers count */
  platform_smart_followers_count?: number;
  /** platform verified type,eg - blue|government|business|none */
  platform_verified_type?: string;
  /** platform of registration */
  registration_platform?: string;
  platform_info?: object;
  /** Owner info */
  owner?: Owner;
  /** multiple items of the platform */
  platform_items?: BindPlatformItem[];
}

export interface Binds {
  rows?: Bind[];
}

export type BindResponse = BaseResponse & {
  data?: Bind;
};

export type BindsResponse = BaseResponse & {
  data?: Binds;
};

export type UnBindsResponse = BaseResponse & {
  data?: boolean;
};

export interface ProfileDTO {
  /** chain id */
  chain_id?: string;
  /** chain icon */
  chain_icon?: string;
  /** address */
  address?: string;
  /** handle */
  handle?: string;
  /** profile_id */
  profile_id?: string;
  /** avatar */
  avatar?: string;
}

export interface ListBindRequest {
  /** type */
  platform?: BindTypeEnum;
  /**
   * owner ids
   * @maxItems 20
   */
  owner_ids?: string[];
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
}

export interface BindPlatformItem {
  /** platform id */
  platform_id?: string;
  /**
   * bind time
   * @format int64
   */
  bind_time?: number;
  /** wallet platform */
  wallet_platform?: string;
  /** platform name */
  platform_name?: string;
  /** chain name */
  chain_name?: string;
}

/** bind request */
export interface AddBindRequest {
  /**
   * code or discord token
   * @example ""
   */
  token?: string;
  /**
   * redirect uri
   * @example ""
   */
  redirect_uri?: string;
  /**
   * wallet address
   * @example ""
   */
  address?: string;
  /**
   * wallet platform
   * @example ""
   */
  wallet_platform?: string;
  /**
   * credential
   * @example ""
   */
  credential?: string;
  /**
   * sync history
   * @example false
   */
  sync_history?: boolean;
  /** business type */
  business_type?: BusinessTypeEnum;
  /** chain name */
  chain_name?: ChainNameEnum;
}

export interface PlatformSearchMultipleDocRequest {
  /** search keyWords */
  keywords?: string;
  /** zone */
  zone?: string;
  /** sort */
  sort?: string[];
  /**
   * nextToken for pagination
   * @format int32
   */
  page?: number;
  /**
   * limit for pagination
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** searchType List */
  types?: SearchTypeEnum[];
  /** search params for flat */
  params?: Record<string, any>;
  /** Is it an exact term */
  exact?: boolean;
}

export interface ListUserRequest {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  tag?: string;
  enrich_option?: FeedEnrichOption;
}

export type GroupResponse = BaseResponse & {
  data?: BadgeCategory[];
};

export interface ListClaimableBadgeRequest {
  /**
   * The badge of get request from the APIS
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  category?: string;
  /** badge check status enum */
  status?: BadgeStatus;
  /** series id */
  series?: string;
  /** is query max level badge */
  include_max_level?: boolean;
  claimable_sort?: ClaimableBadgeSortEnum[];
  /** user profile */
  profile_id?: string;
  /** series ids */
  series_ids?: string[];
}

/** app info */
export interface ClaimableBadge {
  /** badge id */
  id?: string;
  /** chain id */
  chain_id?: string;
  /** badge display name */
  name?: string;
  /** badge nft token id */
  token_id?: string;
  /** @format int64 */
  level?: number;
  /** title */
  title?: string;
  /** background */
  background?: string;
  /** icon */
  icon?: string;
  /** badge image */
  image?: string;
  /** un claim badge image */
  un_claim_image?: string;
  /** series id */
  series?: string;
  /** category */
  category?: string;
  progress?: {
    /** name */
    name?: string;
    /** type */
    type?: string;
    /** user current value */
    value?: string;
    /** user condition gold value */
    condition?: string;
  }[];
  /** strategy */
  strategy?: string;
  /** strategy */
  description?: string;
  /** badge check status enum */
  status?: BadgeStatus;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modify?: number;
  /** @format int64 */
  claim_time?: number;
}

export type BadgeCheckResponse = BaseResponse & {
  data?: boolean;
};

/** Badge check result */
export interface BadgeCheckResult {
  /** @format int64 */
  claimable_badge_count?: number;
  /** @format int64 */
  last_check_timestamp?: number;
  /** badge check status enum */
  check_status?: CheckStatus;
  /** @format int64 */
  total_score?: number;
  /** @format int64 */
  score_rank?: number;
  beat_percent?: string;
}

export type BadgeCheckResultResponse = BaseResponse & {
  /** Badge check result */
  data?: BadgeCheckResult;
};

export interface ClaimableBadgePagination {
  /**
   * limit
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total default 0
   * @format int32
   */
  total?: number;
  /** next token */
  next_token?: string;
  rows?: ClaimableBadge[];
}

export type ClaimableBadgePaginationResponse = BaseResponse & {
  data?: ClaimableBadgePagination;
};

export interface BadgeCategory {
  /** group name */
  name?: string;
  /** group title */
  title?: string;
}

export interface ListSeriesRequest {
  /**
   * The badge of get request from the APIS
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  category?: string;
}

/** series info */
export interface Series {
  /** series id */
  series?: string;
  /** category */
  category?: string;
  /** name */
  name?: string;
  /** desc */
  desc?: string;
  /** detail */
  detail?: string;
  /** logo */
  logo?: string;
  /** @format int32 */
  rizz_total?: number;
  /** @format int32 */
  sort?: number;
  /** app info */
  claimed_badge?: ClaimableBadge;
  /** app info */
  next_badge?: ClaimableBadge;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modify?: number;
}

export interface SeriesPagination {
  /**
   * limit
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total default 0
   * @format int32
   */
  total?: number;
  /** next token */
  next_token?: string;
  rows?: Series[];
}

export type SeriesPaginationResponse = BaseResponse & {
  data?: SeriesPagination;
};

export interface BadgeOperation {
  /** target address */
  target_address?: string;
  /** call data */
  call_data?: string;
}

export type BadgeOperationResponse = BaseResponse & {
  data?: BadgeOperation;
};

export type SeriesResponse = BaseResponse & {
  /** series info */
  data?: Series;
};

export interface DeviceRequest {
  /** sign message by challenge text */
  signature: string;
  /** token */
  token?: string;
  /**
   * time zone offset
   * @format int32
   */
  utc_offset_minutes?: number;
}

/** messages info */
export interface Message {
  /** 社区 id */
  id?: string;
  /** trade|social|c2c */
  business_type?: string;
  /** title */
  title?: string;
  /** app_id */
  params?: string;
  /** address */
  receiver?: string;
  /**
   * created time
   * @format int64
   */
  created?: number;
  content?: string;
}

export interface MessagePagination {
  /**
   * limit
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** next_token */
  next_token?: string;
  rows?: Message[];
}

export type MessagePaginationResponse = BaseResponse & {
  data?: MessagePagination;
};

export interface ListMessageRequest {
  /**
   * Business type filters; at least one item. Must include types such as PROACTIVE_STEWARD where applicable.
   * @minItems 1
   */
  business_types: string[];
  /**
   * Page size between 1 and 20; default 5
   * @format int32
   * @min 1
   * @max 20
   * @default 5
   */
  limit: number;
  /** Cursor for the next page */
  next_token?: string;
  /**
   * Optional lower bound (exclusive): only messages with created strictly greater than this value. Epoch milliseconds recommended, passed as a numeric string.
   * @format int64
   */
  start_time?: number;
  /**
   * Optional message id filter. When combined with next_token, resolution order is defined by the implementation.
   * @minLength 1
   */
  id?: string;
  /**
   * Optional target owner for the query. Proxy access is enforced by gateway/roles; callers without permission should receive 403 when supported by the implementation.
   * @minLength 1
   */
  owner_id?: string;
}

export interface MsgPushRequest {
  /**
   * Target owner id for delivery
   * @minLength 1
   */
  owner_id?: string;
  /** Associated proactive tracker id; forwarded to knotify ext_params for in-app / push correlation (e.g. deep link or unread grouping) */
  tracker_id?: string;
  /**
   * Idempotency key; should be globally unique. Duplicate owner_id plus msg_id should return 200 with idempotent success semantics.
   * @minLength 1
   */
  msg_id?: string;
  /** Required when push_type is TEMPLATE. Examples: PROACTIVE_STEWARD (in-app), PROACTIVE_STEWARD_IMPORT (app push). */
  scene?: string;
  /** Recommended when push_type is CUSTOM */
  custom_title?: string;
  /** Recommended when push_type is CUSTOM */
  custom_body?: string;
  /** Brief card summary; persisted on tracker_record.description when tracker_id is present */
  custom_description?: string;
  /**
   * Proactive card importance score for pool ordering and display; persisted on tracker_record when tracker_id is present
   * @format int64
   */
  importance?: number;
  /** When true, ends the associated tracker in the main flow after record persistence */
  stop?: boolean;
  /** Whether a push is recommended; persisted on tracker_record only (no push is triggered in this API) */
  push?: boolean;
  /** TEMPLATE routes by scene; CUSTOM uses custom_title and custom_body as primary content */
  push_type?: "TEMPLATE" | "CUSTOM";
  /** JSON object extension; omit or null means no extension. Non-object payloads must be rejected with 400. For Redis pub payloads (e.g. suggested question per §4.1.4), keys are mapped by knotify at publish time. */
  ext_params?: Record<string, any>;
}

export interface HoldingsSignalItem {
  /** Business event instance id for deduplication and correlation */
  event_id: string;
  /** Event type code or name from upstream taxonomy */
  event_type?: string;
  /** Extension payload aligned with HTTP conventions: may be a plain string or a JSON document serialized as a string; encoding is agreed between upstream and implementation. */
  detail?: string;
  /** Related asset identifier when applicable */
  asset_id?: string;
  /** Asset or signal category label */
  category?: string;
  /** Human-readable asset symbol (e.g. ticker) */
  asset_symbol?: string;
  /** Image URL for display */
  logo?: string;
}

/** Same shape as MessagePagination (design §4.1.2) */
export interface HoldingsSignalsPagination {
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * Total count
   * @format int32
   */
  total?: number;
  /** Cursor for the next page */
  next_token?: string;
  rows?: HoldingsSignalItem[];
}

export type HoldingsSignalsPaginationResponse = BaseResponse & {
  /** Same shape as MessagePagination (design §4.1.2) */
  data?: HoldingsSignalsPagination;
};

export interface ListHoldingsSignalsRequest {
  /**
   * Page size between 1 and 20; default 5
   * @format int32
   * @min 1
   * @max 20
   * @default 5
   */
  limit: number;
  /** Cursor for the next page */
  next_token?: string;
  /**
   * Optional target owner for holdings signals. When omitted, the caller identity comes from the auth context. Proxy rules align with other notify APIs when enforced by the implementation.
   * @minLength 1
   */
  owner_id?: string;
}

export interface Setting {
  /** receiver id */
  receiver_id?: string;
  /** name */
  name?: string;
  device_status?: DeviceStatus[];
}

export interface SettingRequest {
  /** name */
  name: string;
  /** status,open/close */
  status?: string;
  /**
   * time zone offset
   * @format int32
   */
  utc_offset_minutes?: number;
}

export type Settings = Setting[];

export type SettingsResponse = BaseResponse & {
  data?: Settings;
};

export interface DeviceStatus {
  /** device type */
  device_type?: DeviceType;
  /** status,open/close */
  status?: string;
}

/**
 * Financial goal resource returned by GET/POST/PUT /goals and listGoals rows.
 * Persisted in edgen-tracker tracker_goal.
 */
export interface Goal {
  /** Primary key of the goal (tracker_goal.id). Use in path /goals/{id} for get and update. */
  id: string;
  /** OSP owner identifier (ospOwnerId). Must match the authenticated user unless the call is S2S. */
  owner_id: string;
  /** Persisted goal domain used for downstream query filtering. */
  domain?: DomainEnum;
  /** Human-readable goal name shown in product UI and AI summaries. */
  title: string;
  /** Current lifecycle state (INACTIVE / ACTIVE / COMPLETED / DELETED). */
  status: GoalStatusEnum;
  /** Top-level target amount. May be 0 for INACTIVE onboarding goals. */
  target_value?: number;
  /** Top-level current progress amount. Optional; omitted when never set. */
  current_value?: number;
  /**
   * Goal deadline as Unix epoch milliseconds; persisted as tracker_goal.deadline.
   * Omitted when no deadline was configured.
   * @format int64
   */
  deadline?: number;
  /** Bound account identifiers; may be empty when no accounts are linked to the goal. */
  account_ids?: string[];
  /** JSON string of GoalMetrics. Always present for persisted goals. */
  metrics?: string;
  /** Domain ring category for financial planning goals. */
  category?: GoalCategoryEnum;
  /** Checkup dimension code (101-403), e.g. 103 for Cash-3. See product design §4.1.3. */
  dimension?:
    | 101
    | 102
    | 103
    | 104
    | 105
    | 106
    | 107
    | 201
    | 202
    | 203
    | 301
    | 302
    | 303
    | 401
    | 402
    | 403;
  /** Diagnosis report JSON body (issues, plan, etc.). Not the completeness flag. */
  diagnosis_content?: string;
  /** Read-only completeness flags. Present for V2.8 financial goals after onboarding. */
  completeness?: GoalCompleteness;
  /** Progress display unit, e.g. USD, %, months. */
  value_unit?: string;
  /** Progress bar semantics paired with value_unit. */
  progress_type?: ProgressTypeEnum;
  /**
   * Overall goal progress value (tracker_goal.progress).
   * @format double
   */
  progress?: number;
  /** Goal summary text (tracker_goal.summary). */
  summary?: string;
  /** Goal steps text (tracker_goal.steps). */
  steps?: string;
  /** Ed short feedback for My Goals detail follow-up copy (tracker_goal.review). */
  review?: string;
  /**
   * Last review write time (epoch ms), paired with review.
   * @format int64
   */
  review_time?: number;
  /**
   * Snapshot count of trackers linked to this goal (tracker_goal.tracker_count).
   * Set on ACTIVE create and on activate/replace tracker_specs; omitted on INACTIVE create; not cleared on soft delete.
   */
  tracker_count?: number;
  /**
   * Linked proactive trackers. Only populated when GET /goals/{id}?enrich_trackers=true;
   * omitted on create/update responses and on GET without enrich.
   */
  trackers?: Tracker[];
  /**
   * Row creation time in Unix epoch milliseconds.
   * @format int64
   */
  created: number;
  /**
   * Last update time in Unix epoch milliseconds.
   * @format int64
   */
  modified: number;
}

/**
 * Read-only completeness flags assembled from tracker_goal.completeness JSON.
 * Read-only on POST/PUT; has_data is server-derived (mixture onboarding data + enrich_hash_data on read).
 */
export interface GoalCompleteness {
  /** 1 when tracker_goal.diagnosis_content has a valid report (issues or plan present). */
  has_diagnosis?: 0 | 1;
  /** 1 when required onboarding / activation data collection is complete. */
  has_data?: 0 | 1;
}

/** Aggregated goal statistics for My Goals header (owner from JWT). */
export interface GoalStats {
  /**
   * Earliest goal created time (epoch ms) where status is ACTIVE or DELETED; null when no goals.
   * @format int64
   */
  first_created?: number | null;
  /**
   * Count of goals with status ACTIVE or DELETED.
   * @format int32
   */
  activated_count?: number;
  /**
   * Sum of tracker_goal.tracker_count for goals with status ACTIVE or DELETED (not a live COUNT on tracker table).
   * @format int32
   */
  activated_trackers_count?: number;
}

/** Standard OpenSocial envelope wrapping GoalStats in `data`. */
export type GoalStatsResponse = BaseResponse & {
  /** Aggregated goal statistics for My Goals header (owner from JWT). */
  data?: GoalStats;
};

export interface GoalPagination {
  /** Goals in the current page. */
  rows?: Goal[];
  /** Cursor for the next page; omitted on the last page. */
  next_token?: string;
  /**
   * Optional total count; may be omitted in V2.8.
   * @format int32
   */
  total_count?: number;
}

export type GoalPaginationResponse = BaseResponse & {
  data?: GoalPagination;
};

/**
 * Query parameters for GET /goals (listGoals). Maps to edgen-tracker ListGoalsRequest via Dubbo.
 * owner_id is overwritten from JWT for end users.
 */
export interface ListGoalsRequest {
  /** Owner user ID; defaults to JWT ospOwnerId. */
  owner_id?: string;
  /** Filter by one or more goal statuses. */
  status?: GoalStatusEnum[];
  /** When true, only goals with a valid diagnosis_content report (issues or plan). */
  has_diagnosis?: boolean;
  /** Filter by domain ring category. */
  category?: GoalCategoryEnum;
  /** Filter by checkup dimension codes. */
  dimension?: (
    | 101
    | 102
    | 103
    | 104
    | 105
    | 106
    | 107
    | 201
    | 202
    | 203
    | 301
    | 302
    | 303
    | 401
    | 402
    | 403
  )[];
  /**
   * Sort mode. CREATED = by created time desc (default).
   * PRIORITY = by dimension Engine priority (sort 1–16 ascending).
   */
  sort?: GoalSortEnum;
  /**
   * Page size (default 10, max 20).
   * @format int32
   * @min 1
   * @max 20
   * @default 10
   */
  limit?: number;
  /** Pagination cursor; omit for the first page. */
  next_token?: string;
  /**
   * When true, evaluates mixture onboarding required keys per goal dimension and
   * returns completeness.has_data=1 when all required data is present (may async-persist).
   * @default false
   */
  enrich_hash_data?: boolean;
}

/**
 * Request body for POST /goals (createGoal). Creates a goal and optionally batch-creates trackers.
 * V2.8: status is required (typically INACTIVE for onboarding); INACTIVE create must omit tracker_specs.
 * Downstream: edgen-tracker CreateGoalRequest via Dubbo.
 */
export interface CreateGoalRequest {
  /**
   * Owner user id. Overwritten from JWT ospOwnerId when the caller is an end user;
   * required for S2S and must match the goal owner on later updates.
   */
  owner_id: string;
  /**
   * Display title for the goal; stored on tracker_goal.title.
   * @maxLength 256
   */
  title: string;
  /**
   * Initial goal status. Required on create.
   * Use INACTIVE for onboarding goals; pass ACTIVE to create an in-progress goal directly (requires tracker_specs).
   */
  status: GoalStatusEnum;
  /**
   * Top-level target amount. Optional for INACTIVE onboarding (defaults to 0).
   * Required when creating ACTIVE goals.
   */
  target_value?: number;
  /** Optional top-level current amount at creation. Defaults to 0 when omitted. */
  current_value?: number;
  /**
   * Goal deadline as Unix epoch milliseconds; persisted as tracker_goal.deadline.
   * @format int64
   */
  deadline?: number;
  /** Optional account ids used to scope holdings and metric evaluation for this goal. */
  account_ids?: string[];
  /** Required opaque JSON string (GoalMetrics). Stored as-is by edgen-tracker. */
  metrics: string;
  /**
   * Client-generated idempotency key per owner. Duplicate owner_id + request_id returns
   * the existing goal without creating a second row.
   */
  request_id: string;
  /** Optional domain ring category; may be omitted at create and filled later via updateGoal. */
  category?: GoalCategoryEnum;
  /** Optional checkup dimension code (101-403); may be omitted at create and filled later via updateGoal. */
  dimension?:
    | 101
    | 102
    | 103
    | 104
    | 105
    | 106
    | 107
    | 201
    | 202
    | 203
    | 301
    | 302
    | 303
    | 401
    | 402
    | 403;
  /** Diagnosis report JSON body. Server sets completeness.has_diagnosis=1 when valid. */
  diagnosis_content?: string;
  /** Progress display unit; may be omitted before activation. */
  value_unit?: string;
  /** Progress bar semantics; may be omitted before activation. */
  progress_type?: ProgressTypeEnum;
  /**
   * Overall goal progress value; persisted to tracker_goal.progress.
   * @format double
   */
  progress?: number;
  /** Goal summary text; stored on tracker_goal.summary. */
  summary?: string;
  /**
   * Proactive trackers to create after the goal is saved.
   * Must be omitted for INACTIVE onboarding create.
   * Required when status=ACTIVE or when activating via updateGoal.
   */
  tracker_specs?: CreateTrackerRequest[];
}

/**
 * Request body for PUT /goals/{goal_id} (updateGoal). Partial update: only non-empty fields
 * are sent to edgen-tracker. Omitted fields leave the stored goal unchanged.
 * V2.8: status=DELETED cascades soft-delete to all bound trackers (no tracker_action).
 */
export interface UpdateGoalRequest {
  /** Must match the goal owner_id; used for authorization. Resolved from JWT when not S2S. */
  owner_id: string;
  /** When non-blank, replaces tracker_goal.metrics with this JSON string (GoalMetrics shape). */
  metrics?: string;
  /** When provided, updates top-level tracker_goal.target_value. */
  target_value?: number;
  /** When provided, updates top-level tracker_goal.current_value. */
  current_value?: number;
  /**
   * When non-blank, updates tracker_goal.title.
   * @maxLength 256
   */
  title?: string;
  /**
   * When provided, updates tracker_goal.status.
   * INACTIVE to ACTIVE activation requires tracker_specs (>=1).
   * DELETED cascades tracker status=DELETE.
   */
  status?: GoalStatusEnum;
  /**
   * When provided, updates tracker_goal.deadline (epoch ms).
   * @format int64
   */
  deadline?: number;
  /**
   * When non-empty, replaces the full account_ids list on the goal (not a merge).
   * @minItems 1
   */
  account_ids?: string[];
  /** When provided, updates tracker_goal.category. */
  category?: GoalCategoryEnum;
  /** When provided, updates tracker_goal.dimension (code 101-403). */
  dimension?:
    | 101
    | 102
    | 103
    | 104
    | 105
    | 106
    | 107
    | 201
    | 202
    | 203
    | 301
    | 302
    | 303
    | 401
    | 402
    | 403;
  /** When non-blank, updates diagnosis report and sets completeness.has_diagnosis=1. */
  diagnosis_content?: string;
  /** When provided, updates tracker_goal.value_unit. */
  value_unit?: string;
  /** When provided, updates tracker_goal.progress_type. */
  progress_type?: ProgressTypeEnum;
  /**
   * When provided, updates tracker_goal.progress.
   * @format double
   */
  progress?: number;
  /** When non-blank, updates tracker_goal.summary. */
  summary?: string;
  /** Ed feedback JSON string (tracker_goal.review); must include title and summary keys when set; written during Chat review. */
  review?: string;
  /**
   * Epoch ms of this review; should be sent together with review.
   * @format int64
   */
  review_time?: number;
  /**
   * When non-empty on INACTIVE to ACTIVE, creates trackers via batchCreateTrackers.
   * When non-empty on ACTIVE goal, deletes existing ACTIVE/STOP trackers and recreates.
   * @minItems 1
   */
  tracker_specs?: CreateTrackerRequest[];
}

/**
 * Standard OpenSocial envelope wrapping a single Goal in `data`.
 * HTTP 201 on create, 200 on get/update. `code` and `msg` follow BaseResponse; always set on success.
 * `data` is a full Goal when the goal exists; may be omitted or null when the goal is not found
 * (check application `code`).
 */
export type GoalDetailResponse = BaseResponse & {
  /**
   * Goal payload when the operation succeeds and the goal exists. When present, required
   * Goal fields are defined on the Goal schema.
   */
  data?: Goal;
};

/** Tracker detail */
export interface Tracker {
  /** Unique tracker identifier */
  tracker_id?: string;
  /** Bound goal identifier */
  goal_id?: string;
  /** Owner user ID */
  owner_id?: string;
  /** User-visible title */
  title?: string;
  /** Optional description */
  description?: string;
  /** Tracker lifecycle status */
  status?: TrackerStatusEnum;
  /** How conditions are combined */
  condition_logic?: "AND" | "OR";
  /** Match conditions */
  conditions?: TrackerCondition[];
  /**
   * Created time (epoch milliseconds)
   * @format int64
   */
  created?: number;
  /**
   * Last modified time (epoch milliseconds)
   * @format int64
   */
  modified?: number;
  /**
   * Last trigger time (epoch milliseconds)
   * @format int64
   */
  last_triggered?: number;
  /**
   * Next execution time (epoch milliseconds); earliest among schedule conditions
   * @format int64
   */
  next_triggered?: number;
  /**
   * Total trigger count
   * @format int64
   */
  triggers_count?: number;
  /** Creation source */
  created_by?: "USER_CLICK" | "AI_DIALOG";
  /**
   * Total record count for this tracker (populated on listTrackersByOwner)
   * @format int64
   */
  total_record?: number;
  /**
   * Created time of the latest record (epoch milliseconds); populated on list
   * @format int64
   */
  last_record?: number;
  /**
   * Unread record count; cleared when tracker is marked read
   * @format int64
   */
  unread_count?: number;
  /** Summary of the latest trigger for list display */
  last_trigger_content?: string;
  /** Title of the latest trigger for list display */
  last_trigger_title?: string;
  /** Optional payload for trigger record; populated on getTrackerRecord or list with details. Calendar UI fields (e.g. requires_user_action button label) are embedded in this JSON string. */
  payload?: string;
  /** Denormalized schedule frequency (written by server from schedule conditions) */
  schedule_freq?: ScheduleFreqEnum;
  /** Denormalized cron expression for recurring schedules; null for once */
  schedule_expr?: string;
  /** OTS recall values; weekly dow 0-6, monthly dom+100 (101-131), once epoch ms */
  schedule_value?: number[];
  /**
   * Tracker schedule effective start inclusive (epoch milliseconds, UTC); default created on create
   * @format int64
   */
  start?: number;
  /**
   * Tracker schedule effective end inclusive (epoch milliseconds, UTC); null means no upper bound
   * @format int64
   */
  end?: number;
  /** Business domain for calendar styling and filtering (finance / invest) */
  domain?: DomainEnum;
  /** Who executes this tracker (USER / AI / SYSTEM) */
  actor?: TrackerActorEnum;
  /** Calendar/card display type for client UI (caller-defined, e.g. default / compact) */
  display_type?: string;
}

/** Tracker match condition; maps to edgen-tracker TrackerConditionDTO */
export interface TrackerCondition {
  /** Condition ID; maps to TrackerConditionDTO.id (server-generated on create; pass existing ID on update) */
  id?: string;
  /** Associated tracker ID */
  tracker_id?: string;
  /** Condition type */
  condition_type?: "tag_match" | "numeric" | "semantic" | "schedule";
  /** For tag_match, the dimension name (e.g. ticker); for numeric, the metrics field name (e.g. change_pct); empty for semantic / schedule */
  match_key?: string;
  /** For tag_match, e.g. in; for numeric, e.g. >=, <=; for schedule, e.g. once, recurring */
  match_op?: string;
  /** Match values: tag labels, numeric thresholds, semantic intent text, or for schedule the expression in match_values[0] (once = epoch ms string, recurring = 5-part UTC cron) */
  match_values?: string[];
  /** Asset type for ticker/symbol matching (e.g. STOCK/TOKEN), mapped to TrackerConditionDTO.assetType. Recommended for tag_match with ticker-like match_key to avoid symbol collision across asset classes. */
  asset_type?: "TOKEN" | "STOCK";
  /** Optional filter key for ticker, theme, or topic (maps to TrackerConditionDTO.sourceKey). When set with source_values, used for event source matching; if omitted for tag_match on ticker/theme/topic, the server may derive from match_key and match_values. */
  source_key?: string;
  /** Optional filter values for source_key (maps to TrackerConditionDTO.sourceValues) */
  source_values?: string[];
}

/** Create tracker request; maps to edgen-tracker CreateTrackerRequest */
export interface CreateTrackerRequest {
  /**
   * Tracker title
   * @maxLength 200
   */
  title: string;
  /** Owner user ID; may be filled from auth context; when provided by the client it must match the authenticated user */
  owner_id?: string;
  /** How conditions are combined */
  condition_logic: "AND" | "OR";
  /**
   * At least one match condition
   * @minItems 1
   */
  conditions: TrackerCondition[];
  /** Pre-generated tracker ID from draft; used as tracker primary key on create (idempotent) */
  id?: string;
  /** Optional description */
  description?: string;
  /** Business payload passed to downstream on schedule trigger (JSON string); maps to CreateTrackerRequest.payload / OTS column payload */
  payload?: string;
  /** Creation source */
  created_by?: "USER_CLICK" | "AI_DIALOG";
  /** Idempotency key; should be globally unique. Duplicate request_id should return 200 with idempotent success semantics. */
  request_id?: string;
}

/** Update tracker request */
export interface UpdateTrackerRequest {
  /** Resource owner for authorization (only the owner may update) */
  owner_id: string;
  /** Tracker title */
  title?: string;
  /** Optional description */
  description?: string;
  /** Business payload passed to downstream on schedule trigger (JSON string); maps to UpdateTrackerRequest.payload / OTS column payload */
  payload?: string;
  /** How conditions are combined */
  condition_logic?: "AND" | "OR";
  /** New status; at least one of status, conditions, title, description, payload, condition_logic, or unread_count must be provided */
  status?: "ACTIVE" | "STOP";
  /** Full replacement of the condition list when provided */
  conditions?: TrackerCondition[];
  /**
   * Pass 0 to mark tracker as read (clears unread count); omit otherwise
   * @format int64
   */
  unread_count?: number;
}

/** Delete tracker request */
export interface DeleteTrackerRequest {
  /** Resource owner for authorization (only the owner may delete) */
  owner_id: string;
}

/** Paginated list by owner; maps to ListTrackersByOwnerRequest (OTS nextToken + limit). When sort_field/sort_order are omitted, the server defaults to created DESC. */
export interface ListTrackersRequest {
  /**
   * Owner user ID
   * @minLength 1
   */
  owner_id: string;
  /** OTS search index pagination token; omit for first page */
  next_token?: string;
  /**
   * Page size (max 100)
   * @format int32
   * @min 1
   * @max 100
   * @default 20
   */
  limit: number;
  /** When true, return only trackers with unread_count > 0 */
  unread_only?: boolean;
  /** Optional tracker lifecycle status filter. */
  statuses?: TrackerStatusEnum[];
  /** Optional tracker actor filter. */
  actors?: TrackerActorEnum[];
  /** Optional tracker display-type filter. */
  display_types?: string[];
  /** Include goal-bound tracker rows in the filtered result. */
  include_goal_trackers?: boolean;
  /** Sort field (OTS search index column) */
  sort_field?:
    | "created"
    | "last_triggered"
    | "next_triggered"
    | "triggers_count";
  /** Sort direction */
  sort_order?: "ASC" | "DESC";
}

export interface TrackerPagination {
  /** Trackers in the current page */
  rows?: Tracker[];
  /**
   * Page size used for this query
   * @format int32
   */
  limit?: number;
  /**
   * Total count when available
   * @format int32
   */
  total?: number;
  /** Pagination token for the next page */
  next_token?: string;
}

export type TrackerResponse = BaseResponse & {
  /** Tracker detail */
  data?: Tracker;
};

export type TrackerPaginationResponse = BaseResponse & {
  data?: TrackerPagination;
};

export type CreateTrackerResponse = BaseResponse & {
  data?: {
    /** Newly created tracker ID (Dubbo createTracker return value) */
    tracker_id?: string;
  };
};

/** Create tracker draft request for a brief record or guru CIK */
export interface CreateTrackerDraftRequest {
  /** Brief record identifier (legacy mode) */
  record_id?: string;
  /** Guru mode source type */
  source_type?: "guru";
  /** Guru CIK identifier when source_type is guru */
  cik?: string;
}

/** Tracker draft payload for create tracker confirmation */
export interface TrackerDraft {
  /** Pre-generated tracker ID; pass to createTracker as id for idempotent creation */
  id?: string;
  /** Draft tracker title */
  title: string;
  /** Draft tracker description */
  description?: string;
  /** How conditions are combined */
  condition_logic: "AND" | "OR";
  /**
   * Draft tracker conditions
   * @minItems 1
   */
  conditions: TrackerCondition[];
}

export type CreateTrackerDraftResponse = BaseResponse & {
  /** Tracker draft payload for create tracker confirmation */
  data?: TrackerDraft;
};

/** Tracker trigger or delivery record */
export interface TrackerRecord {
  /** Record unique identifier */
  id?: string;
  /** Associated tracker ID */
  tracker_id?: string;
  /** Associated goal ID */
  goal_id?: string;
  /** Owner user ID */
  owner_id?: string;
  /** Trigger event ID */
  event_id?: string;
  /**
   * Created time (epoch milliseconds)
   * @format int64
   */
  created?: number;
  /**
   * Last modified time (epoch milliseconds)
   * @format int64
   */
  modified?: number;
  /**
   * Completed/read time (epoch milliseconds); null means not completed
   * @format int64
   */
  read_at?: number;
  /** Record title */
  title?: string;
  /** User action description stored on the record */
  user_action_desc?: string;
  /** Record description */
  description?: string;
  /** Content card / body text */
  content?: string;
  /** Event type for rendering branch and icon */
  event_type?: string;
  /**
   * Optional importance score
   * @format int64
   */
  importance?: number;
  /** Domain/category stored on the record */
  domain?: "FINANCE" | "INVEST" | "OTHER";
  /** Subject key for track button state, BASE64-encoded UTF-8 of plain key (e.g. ticker:NVDA) */
  tracker_key?: string;
  /** Enriched goal when goal enrichment is enabled for this record */
  goal?: Goal;
  /** Enriched tracker when enrich_tracker=true for this record */
  tracker?: Tracker;
  /** Brief card business type (hook_article / alpha_pick_total / alpha_pick_single / portfolio_check / plan_move / signal / proactive, etc.) */
  type?: string;
  /** Card-source extension JSON as stored on tracker_record.payload (cta_primary, angle, cta_buttons, pickInfo, ...) */
  payload?: string;
}

/** Query parameters for GET /trackers/{id}/records. Tracker id is supplied via the path; this object only carries pagination and optional owner filter. */
export interface ListTrackerRecordsRequest {
  /** OTS search index pagination token; null for first page */
  next_token?: string;
  /**
   * Page size (max 100)
   * @format int32
   * @min 1
   * @max 100
   * @default 20
   */
  limit: number;
  /** Filter by owner user ID (optional) */
  owner_id?: string;
  /** Domain filter for owner aggregate list (id=-1) */
  domain?: "FINANCE" | "INVEST" | "OTHER";
  /**
   * Start timestamp in epoch milliseconds for owner aggregate list
   * @format int64
   */
  start_time?: number;
  /**
   * Include tracker map in pagination response
   * @default false
   */
  enrich_tracker?: boolean;
  /**
   * When true, return only records where read_at is null or missing
   * @default false
   */
  unread?: boolean;
  /** Brief feed mode; recommend = Brief recommend stream */
  query_type?: BriefQueryTypeEnum;
  /** Ad channel; present means ad-attribution session */
  query_channel?: BriefQueryChannelEnum;
  /** Interest category (one of 11 brief categories); present means interest-ad session */
  query_source?: string;
  /** Landing business identifier; when query_channel=THEME_RANK this is the OpenData theme slug (synced from backend openapi.yaml) */
  landing_id?: string;
}

export interface TrackerRecordPagination {
  /** Tracker records in the current page */
  rows?: TrackerRecord[];
  /**
   * Page size used for this query
   * @format int32
   */
  limit?: number;
  /**
   * Total count when available
   * @format int32
   */
  total?: number;
  /** Opaque pagination cursor for the next page (BASE64-encoded; pass through as-is, do not parse on client) */
  next_token?: string;
  /**
   * Latest read timestamp at user level (epoch milliseconds)
   * @format int64
   */
  last_read_at?: number;
}

export type TrackerRecordResponse = BaseResponse & {
  /** Tracker trigger or delivery record */
  data?: TrackerRecord;
};

export type TrackerRecordPaginationResponse = BaseResponse & {
  data?: TrackerRecordPagination;
};

/** Request body for PATCH /records/{id} */
export interface UpdateTrackerRecordRequest {
  /** User action description to update on the record */
  user_action_desc?: string;
  /**
   * Read or completed timestamp in epoch milliseconds
   * @format int64
   */
  read_at?: number;
  /** Brief interaction state written to tracker_record.interaction_state. Values: EXPOSED / VIEWED_DETAIL / CLICKED_BUTTON. Used by mark-read flow; ignored for non-brief record updates. */
  interaction_state?: "EXPOSED" | "VIEWED_DETAIL" | "CLICKED_BUTTON";
}

export type UpdateTrackerRecordResponse = BaseResponse & {
  data?: {
    /**
     * Remaining daily quota; unlimited users return -1
     * @format int32
     */
    remaining_quota?: number;
  };
};

/** A single schedule occurrence in a calendar time window */
export interface ScheduleCalendarEvent {
  /** Tracker identifier */
  tracker_id?: string;
  /** User-visible tracker title */
  title?: string;
  /** Bound goal identifier, if any */
  goal_id?: string;
  /** Goal title from tracker_goal; populated when goal_id is set */
  goal_title?: string;
  /** Tracker description; calendar UI uses as goal context when goal_title is absent */
  description?: string;
  /** Business payload for card display (JSON string). Calendar UI fields (e.g. action_label, content, requires_user_action) are embedded in this JSON. */
  payload?: string;
  /** Tracker lifecycle status (may include DELETE for historical calendar) */
  status?: "ACTIVE" | "STOP" | "COMPLETED" | "DELETE";
  /** Denormalized schedule frequency */
  schedule_freq?: ScheduleFreqEnum;
  /** Business domain for card styling */
  domain?: DomainEnum;
  /** Who executes this tracker */
  actor?: TrackerActorEnum;
  /** Calendar/card display type echoed from tracker (caller-defined) */
  display_type?: string;
  /**
   * Occurrence trigger time (epoch milliseconds, UTC)
   * @format int64
   */
  trigger_at?: number;
  /** Stable key for completion; tracker_id + "_" + trigger_at */
  occurrence_key?: string;
  /** Whether a tracker_record exists for this occurrence_key */
  completed?: boolean;
  /** Tracker record title (if completed) */
  record_title?: string;
  /**
   * Tracker last_triggered timestamp (epoch milliseconds, UTC)
   * @format int64
   */
  last_triggered?: number;
  /**
   * Tracker unread record count from tracker.unread_count
   * @format int64
   */
  unread_count?: number;
}

/** Schedule calendar query payload */
export interface ScheduleCalendarEventsData {
  /** Occurrences sorted by trigger_at ascending, capped by limit */
  events?: ScheduleCalendarEvent[];
}

export type ScheduleCalendarEventsResponse = BaseResponse & {
  /** Schedule calendar query payload */
  data?: ScheduleCalendarEventsData;
};

export interface OperationScoreRequest {
  /** activity view id */
  view_id: string;
  /**
   * score
   * @format double
   * @min 0
   * @max 10
   */
  score: number;
  /**
   * start time
   * @format int64
   */
  start_time: number;
  /**
   * end time
   * @format int64
   */
  end_time: number;
  /** osp platform chain id */
  chain_id?: string;
}

export interface OperationBlockActivityRequest {
  /** activity view id */
  view_id: string;
}

export interface OperationBlockUserActivityRequest {
  /** user id */
  user_id: string;
}

export interface Balance {
  /** osp or aa address */
  address?: string;
  data?: BalanceData[];
}

export interface BalancePagination {
  rows?: Balance[];
}

export interface BalanceRequest {
  /** owner address eoa or aa address */
  address?: string[];
  /** contract address */
  token_address?: string[];
}

export type BalancePaginationResponse = BaseResponse & {
  data?: BalancePagination;
};

export interface BalanceData {
  /** osp or aa address */
  address?: string;
  /** latest price */
  price?: string;
  /** amount value */
  balance?: string;
  /** token symbol */
  symbol?: string;
}

export interface ActivityAuditNotifyRequest {
  /** checksum */
  checksum?: string;
  /** json string */
  content?: string;
}

export interface BindRequest {
  platform_type: "TELEGRAM" | "TWITTER";
  platform_user_id?: string;
  platform_user_name?: string;
  token?: string;
  /** owner id */
  owner_id?: string;
  platform_info?: object;
}

export interface BindJoinChatGroupRequest {
  platform_type: "TELEGRAM" | "DISCORD";
  platform_user_id: string;
}

export type OwnerInvitesResponse = BaseResponse & {
  data?: OwnerInvites;
};

export interface OwnerInvites {
  /** owner id */
  owner_id?: string;
}

export interface TaskVerifyRequest {
  owner_id: string;
  task_code: string;
  eoa_addresses?: string[];
}

export interface TaskRewardRequest {
  /** Event Name */
  name: string;
  /**
   * Event Time
   * @format int64
   */
  time: number;
  /** owner id */
  owner_id: string;
  /** body */
  body?: object;
}

export interface ChatGroupJoinVerify {
  /** verify result */
  result: boolean;
}

export interface ChatGroupJoinVerifyRequest {
  /** channel id */
  channel: ChatGroupChannel;
  /** chat group id */
  group_id: string;
  /** account */
  account: string;
}

export type ChatGroupJoinVerifyResponse = BaseResponse & {
  data?: ChatGroupJoinVerify;
};

export interface ExternalActivity {
  /** owner id */
  owner_id?: string;
  /** author id */
  author_id?: string;
  /** feed source */
  source?: "OSP" | "TWITTER" | "YOUTUBE";
  /** title */
  title?: string;
  /** content */
  content?: string;
  medias?: ExternalActivityMedia[];
  urls?: ExternalActivityUrl[];
  /** link */
  link?: string;
  /** author name */
  author_name?: string;
  /** author avatar */
  author_avatar?: string;
  /**
   * activity time
   * @format int64
   */
  activity_time?: number;
  hash_tags?: string[];
}

export interface ExternalActivityMedia {
  /** media url */
  media_url?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  type?: string;
}

export interface ExternalActivityUrl {
  /** url */
  url?: string;
  /** og or twitter title */
  title?: string;
  /** og or twitter description */
  description?: string;
  /** og or twitter image */
  image?: string;
  /** embed html */
  html?: string;
}

export interface UpsertPortraitRequest {
  /** ownerId */
  owner_id?: string;
  /** eoaAddress */
  eoa_address?: string;
  /** twitterInfo */
  twitter_info?: string;
  /** youtubeInfo */
  youtube_info?: string;
  /** insInfo */
  ins_info?: string;
  /** tiktok Info */
  tiktok_info?: string;
  /** tiktokInfo */
  summary?: string;
  keyword?: string[];
}

export interface ExternalNewRequest {
  /** The news Ids */
  ids?: string[];
}

export interface ListSourceDataRequest {
  next_token?: string;
  /** @format int32 */
  limit?: number;
  business_id?: string[];
  platform?: string;
  mention?: string[];
  /** search by common fields and nested fields */
  params?: Record<string, any>;
  enrich_option?: {
    ecosystem_tvl?: boolean;
    token_kline?: boolean;
    people_social_metrics?: boolean;
    project_social_metrics?: boolean;
  };
}

export interface SourceData {
  id?: string;
  type?: string;
  business_id?: string;
  platform?: string;
  content?: string;
  mention?: string[];
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modified?: number;
  text?: string;
  /** author detail */
  author?: Record<string, any>;
  /** property detail */
  property?: Record<string, any>;
  tvl?: Record<
    string,
    {
      /** @format int64 */
      date?: number;
      val?: string;
    }[]
  >;
  kline?: Record<string, Kline[]>;
  social_metrics?: Record<
    string,
    {
      /** @format int64 */
      followers_count?: number;
      /** @format int64 */
      smart_followers_count?: number;
      /** @format int64 */
      impression?: number;
      /** @format int64 */
      follower_rank?: number;
      /** @format int64 */
      smart_follower_rank?: number;
      /** @format int64 */
      impression_rank?: number;
      /** @format int64 */
      followers_total?: number;
      /** @format int64 */
      smart_followers_total?: number;
      /** @format int64 */
      impressions_total?: number;
      /** @format int64 */
      op_time?: number;
    }
  >;
}

export interface SourceDataPagination {
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int32
   */
  total?: number;
  /** 翻页token */
  next_token?: string;
  rows?: SourceData[];
}

export type SourceDataPaginationResponse = BaseResponse & {
  data?: SourceDataPagination;
};

export type SourceDataResponse = BaseResponse & {
  data?: SourceData;
};

export type RebatePaginationResponse = BaseResponse & {
  data?: RebatePagination;
};

export interface RebatePagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Rebate[];
}

export interface Rebate {
  /** Owner info */
  giver?: Owner;
  /** Rebate amount */
  amount?: number;
  /**
   * rebate create time
   * @format int64
   */
  created?: number;
}

export type RebateSummaryResponse = BaseResponse & {
  data?: RebateSummary;
};

export interface RebateSummary {
  /** pending amount */
  pending_amount?: number;
  /** claimed amount */
  claimed_amount?: number;
  /** claimable amount */
  claimable_amount?: number;
}

/** recommend user info */
export interface RecommendThirdUser {
  /** third user id */
  id?: string;
  /** user handle */
  handle?: string;
  /** user profile image url */
  profile_image_url?: string;
  /**
   * user follow count
   * @format int64
   */
  follow_count?: number;
  /** user display name */
  display_name?: string;
}

export interface RecommendThirdUserPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: RecommendThirdUser[];
}

export type RecommendThirdUserPaginationResponse = BaseResponse & {
  data?: RecommendThirdUserPagination;
};

export interface SecurityVerifyRequest {
  /** ownerId */
  ownerId?: string;
  /** email */
  email?: string;
  /** phone */
  phone?: string;
  /** ip */
  ip?: string;
  scene?: SecurityVerifyScene;
}

/** Policy info */
export interface Policy {
  /** Policy id */
  id?: string;
  /** blacklist */
  blacklist?: string;
  /** whitelist */
  whitelist?: string;
  /** globalMaximums */
  global_maximums?: string;
  /** userMaximums */
  user_maximums?: string;
  /** @format int64 */
  expiry?: number;
  /** @format int64 */
  end_time?: number;
  /** @format int64 */
  modified?: number;
  /** @format int64 */
  created?: number;
}

export interface RegisterApplicationRequest {
  /** app name */
  name: string;
  /** app desc */
  desc?: string;
  /** app chain_id */
  chain_id: string;
  /** signer address */
  signer_address?: string;
  /** app_id */
  app_id?: string;
}

export interface GetApplicationsRequest {
  /**
   * The amount of activities requested from the APIs
   * @format int32
   * @max 20
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
}

/** app info */
export interface Application {
  /** app */
  id?: string;
  /** app owner address */
  owner?: string;
  /** app name */
  name?: string;
  /** app key */
  public_key?: string;
  /** signer address */
  signer_address?: string;
  /** app desc */
  desc?: string;
  /** @format int64 */
  modified?: number;
  /** @format int64 */
  created?: number;
  /** Policy info */
  policy?: Policy;
  /** community id */
  community_id?: string;
  /** theme_id */
  theme_id?: string;
}

export type ApplicationResponse = BaseResponse & {
  /** app info */
  data?: Application;
};

export interface ApplicationPagination {
  /**
   * limit
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** next_token */
  next_token?: string;
  rows?: Application[];
}

export type ApplicationPaginationResponse = BaseResponse & {
  data?: ApplicationPagination;
};

export interface Member {
  /**
   * owner id
   * @example 123234234233423
   */
  id?: string;
  /** membership status */
  status?: MemberStatusEnum;
  /**
   * is auto renewal
   * @example true
   */
  auto_renewal?: boolean;
  /**
   * first time
   * @format int64
   * @example 1751435277220
   */
  first_time?: number;
  /**
   * effect time
   * @format int64
   * @example 1751435277220
   */
  effect_time?: number;
  /**
   * expire time
   * @format int64
   * @example 1752249600000
   */
  expire_time?: number;
  /**
   * remain minutes
   * @format int64
   * @example 30
   */
  remain_minutes?: number;
  product?: MemberProduct;
  order?: MemberOrder;
  renewal_product?: MemberProduct;
  /** Member credit balance summary */
  credit?: MemberCredit;
  /** List of available products with action status and product type */
  available_products?: {
    /**
     * Product ID
     * @example "expert_year_20260127"
     */
    product_id?: string;
    /**
     * Action type, UPGRADE / RENEW / UPGRADE_TO_LATEST / PURCHASE
     * @example "UPGRADE"
     */
    action?: "UPGRADE" | "RENEW" | "UPGRADE_TO_LATEST" | "PURCHASE";
    /**
     * Product type, normal / trial (used to distinguish trial products)
     * @example "normal"
     */
    product_type?: "normal" | "trial";
  }[];
  /** Minimal device metadata for tick delivery decision. */
  track_meta?: {
    /** App instance id (may be empty if not reported). */
    ga_instance_id?: string;
    /** Client platform: ios / android / web / h5 */
    platform?: string;
    /**
     * Last active timestamp on app (iOS/Android) in milliseconds.
     * @format int64
     */
    last_app_at?: number;
  };
}

export interface MemberEnrichOption {
  /**
   * if you need to return the credit balance information, set this to true (default). Set to false to skip credit query. Only available for active members with credit-enabled products.
   * @default true
   */
  with_credit?: boolean;
  /**
   * if you need to return available_products , set this to true (default).
   * @default true
   */
  with_available_products?: boolean;
}

export interface GetMemberRequest {
  enrich?: MemberEnrichOption;
  /** language to return the member information in. */
  language?: string;
}

export type MemberResponse = BaseResponse & {
  data?: Member;
};

/** Member credit balance summary */
export interface MemberCredit {
  /**
   * Total credit amount
   * @format int64
   */
  total?: number;
  /**
   * Used credit amount
   * @format int64
   */
  used?: number;
  /**
   * Available credit amount
   * @format int64
   */
  available?: number;
  /**
   * Total credit from last period (carry-over amount)
   * @format int64
   */
  rollover?: number;
  /**
   * Total credit from permanent amount
   * @format int64
   */
  permanent?: number;
  /**
   * Current cycle policyId
   * @example "pro_month_260101_01"
   */
  policy_id?: string;
  /**
   * Credit cycle start time (milliseconds timestamp, calculated from segments resetTime)
   * @format int64
   * @example 1704067200000
   */
  start_time?: number;
  /**
   * Credit cycle end time (milliseconds timestamp, calculated from resetTime + 1 natural month/year)
   * @format int64
   * @example 1706745600000
   */
  end_time?: number;
}

export interface MemberRetentionStats {
  owner_id?: string;
  /** @format int64 */
  effect_time?: number;
  /** @format int64 */
  expire_time?: number;
  member_days?: number;
  /** @format int64 */
  chat_count?: number | null;
  /** @format int64 */
  signal_count?: number | null;
  /** @format int64 */
  alpha_earning_count?: number | null;
  /** @format int64 */
  alpha_ipo_count?: number | null;
  /** @format int64 */
  alpha_ai_pick_count?: number | null;
  /** @format int64 */
  report_daily_report_count?: number | null;
  /** @format int64 */
  report_report_360_count?: number | null;
  /**
   * @maxItems 3
   * @minItems 3
   */
  summary?: string[];
  /** @format int64 */
  updated_at?: number;
}

export type MemberRetentionStatsResponse = BaseResponse & {
  data?: MemberRetentionStats;
};

export interface MemberEquity {
  /**
   * equity id
   * @example "demo_1"
   */
  id?: string;
  /**
   * equity name
   * @example "demo_1"
   */
  name?: string;
  /**
   * equity limit
   * @example 100
   */
  params?: string;
  /**
   * equity category
   * @example "Trading Strategy"
   */
  category?: string;
  /**
   * equity status
   * @example "OWN"
   */
  status?: "OWN" | "NOT_OWN";
  /**
   * equity weight
   * @format int64
   * @example 1
   */
  weight?: number;
  /** equity remark */
  remark?: string;
  type?: string;
  internal_category?: string;
  /** member equity status */
  equity_status?: "ACTIVE" | "INACTIVE";
}

export interface MemberOrder {
  /**
   * order id
   * @example 123234234233423
   */
  id?: string;
  /**
   * effect time
   * @format int64
   * @example 1751435277220
   */
  effect_time?: number;
  /**
   * expire time
   * @format int64
   * @example 1752249600000
   */
  expire_time?: number;
  /** condition type */
  condition_type?: "REWARD" | "TOKEN";
  /**
   * pay channel
   * @example "PAYPAL"
   */
  pay_channel?: string;
}

export interface MemberProduct {
  /**
   * product id
   * @example "pro_month"
   */
  id?: string;
  /**
   * product name
   * @example "pro"
   */
  name?: string;
  /**
   * the price of the product
   * @example 0.99
   */
  price?: number;
  /**
   * is support auto renewal
   * @example true
   */
  auto_renewal?: boolean;
  /** all equities */
  equities?: MemberEquity[];
  /** product type */
  type?: "TRIAL" | "NORMAL" | "REWARD" | "DAPP";
  /** all prices config */
  currencies?: MemberProductCurrency[];
  /** product pay cycle */
  pay_cycle?: "MONTH" | "YEAR" | "WEEK" | "LIFETIME" | "DAY";
  /** product status */
  status?: "ACTIVE" | "HIDDEN" | "DISABLE";
  /** product level */
  level?: MemberProductLevelEnum;
  /**
   * Capability domains for this product (`INVEST`, `PLAN`).
   * Universal products include both values.
   * @example ["INVEST","PLAN"]
   */
  domains?: MemberProductDomainEnum[];
  /**
   * sort
   * @format int32
   */
  sort?: number;
  discount?: {
    /**
     * start time
     * @format int64
     */
    start_time?: number;
    /**
     * end time
     * @format int64
     */
    end_time?: number;
    /**
     * percent off
     * @example 20
     */
    percent_off?: number;
    /**
     * campaign
     * @example "christmas"
     */
    campaign?: string;
  };
  /** renewal product id */
  renewal_id?: string;
  /** Payment configs per channel */
  payment_configs?: MemberProductPaymentConfig[];
}

export type MemberProductResponse = BaseResponse & {
  data?: MemberProduct[];
};

export interface MemberProductPaymentConfig {
  /** Channel identifier, e.g. IAB (Google Play), IAP (Apple IAP) */
  channel?: string;
  /** Channel config status, ACTIVE (enabled), INACTIVE (disabled) */
  status?: string;
  /** Store product ID for this channel (Apple product_id, Google Play product ID) */
  product_id?: string;
  /** Store plan ID for this channel (Google plan_id, Google Play plan_id ID) */
  plan_id?: string;
  /**
   * Discount percentage based on original price (0-100), for frontend display. e.g., 20 means 20% off, actual price is 80% of original price
   * @format int32
   * @example 20
   */
  discount_percent?: number;
  /** List of offers supported by this channel */
  offers?: MemberProductPaymentConfigOffer[];
}

export interface MemberProductPaymentConfigOffer {
  /** Offer status, ACTIVE (enabled), INACTIVE (disabled) */
  status?: string;
  /** Offer code, e.g. intro_free_trial_7d (Apple), google_offer_free_7d (Google) */
  code?: string;
  /** Offer type, introductory or promotional */
  type?: string;
  /** Display name, e.g. 7-day free trial */
  reference_name?: string;
}

export interface MemberProductCurrency {
  /**
   * the type of the currency
   * @example "crypto"
   */
  type?: string;
  /**
   * the channel of the currency
   * @example "paypal/wallet"
   */
  channel?: string;
  /**
   * currency
   * @example "USDC"
   */
  currency?: string;
  /**
   * address
   * @example "contract address"
   */
  address?: string;
  /**
   * the price of the currency
   * @example 0.99
   */
  price?: number;
  /**
   * the chain id of the currency
   * @example 8453
   */
  chain_id?: string;
  /**
   * the ecosystem of the currency
   * @example "bnb/base"
   */
  ecosystem?: string;
  /**
   * the icon of the currency
   * @example "ipfs://xx"
   */
  icon?: string;
  /**
   * the display description of the currency
   * @example "USDT via ERC-20"
   */
  description?: string;
  /**
   * the display decimals of the currency
   * @format int32
   */
  decimals?: number;
}

export interface RedeemCode {
  /**
   * Reward Code, Primary Key
   * @example "MPR-A1B2-C3D4-E5F6"
   */
  code?: string;
  /**
   * Redemption User ID (Filled After Redemption)
   * @example "user123"
   */
  owner_id?: string;
  /**
   * MEMBER, AURA (Filled After Redemption)
   * @example "MEMBER"
   */
  redeemed_type?: RedeemTypeEnum;
  /**
   * Redemption Time (Filled After Redemption)
   * @format int64
   * @example 1634567890000
   */
  redeemed_time?: number;
  /** Redemption Equity */
  redeemed_equity?: object;
  /** Redemption Sub Type */
  sub_type?: string;
  /** Redemption condition */
  redeem_condition?: object;
}

export interface RedeemCodeResponse {
  redeem_code?: RedeemCode;
}

export type RedeemCodePaginationResponse = BaseResponse & {
  data?: RedeemCodePagination;
};

export interface RedeemCodePagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** next page start position */
  next_token?: string;
  /**
   * total
   * @format int32
   */
  total?: number;
  rows?: RedeemCode[];
}

export type EquityResponse = BaseResponse & {
  data?: EquityGroups[];
};

export type EquityGrantQuantityResponse = BaseResponse & {
  /**
   * grantable quantity for current equity code
   * @format int32
   */
  data?: number;
};

export type EquityGrantResultResponse = BaseResponse & {
  /** whether grant equity succeeded */
  data?: boolean;
};

export interface EquityGroups {
  internal_category?: string;
  equities?: MemberEquity[];
  /**
   * equity name
   * @example "demo_1"
   */
  name?: string;
  /**
   * equity category
   * @example "Trading Strategy"
   */
  category?: string;
  /**
   * equity weight
   * @format int64
   * @example 1
   */
  weight?: number;
  /** equity remark */
  remark?: string;
  scenario_cost?: Record<
    string,
    {
      /** @format int64 */
      min?: number;
      /** @format int64 */
      fixed?: number;
    }
  >;
}

export type EquityStatusEnum = any;

/** Credit use request for perplexia */
export interface UseCreditRequest {
  /** User ID (logged-in ownerId, required for member credit) */
  owner_id: string;
  /**
   * Amount of credit to use
   * @format decimal
   */
  amount?: number;
  /** Business ID for idempotency */
  business_id: string;
  /** credit use scenario */
  scenario_type: string;
}

/** Request body for POST /records user action completed flow */
export interface CreateUserActionRecordRequest {
  /** Tracker identifier for the schedule todo */
  tracker_id: string;
  /** Deterministic record identifier for idempotent create */
  record_id: string;
  /** Optional user action description for the created record */
  user_action_desc?: string;
}

export type CreateTrackerRecordResponse = BaseResponse & {
  data?: {
    /** Created tracker record identifier (deterministic for user action completed) */
    record_id?: string;
  };
};

/**
 * Query parameters for GET /records (listRecords). Owner-aggregated query;
 * owner_id is overwritten from JWT for end users.
 */
export interface ListRecordsRequest {
  /**
   * Page size (max 100)
   * @format int32
   * @min 1
   * @max 100
   * @default 20
   */
  limit: number;
  /** Pagination token; omit for the first page */
  next_token?: string;
  /** Optional owner filter */
  owner_id?: string;
  /** Domain filter for owner aggregate query */
  domain?: DomainEnum;
  /**
   * Start timestamp in epoch milliseconds for owner aggregate query
   * @format int64
   */
  start_time?: number;
  /**
   * Include tracker map for current page records
   * @default false
   */
  enrich_tracker?: boolean;
  /**
   * When true, return only records where read_at is null or missing
   * @default false
   */
  unread?: boolean;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string =
    "https://{region}-{environment}.opensocial.{domain}/v2/tracker/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Open Social API
 * @version 2.0.0
 * @baseUrl https://{region}-{environment}.opensocial.{domain}/v2/tracker/
 *
 * The Tracker API for Open Social Project
 */
export class TrackerClient<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  goals = {
    /**
     * @description Lists goals for an owner with filters and cursor pagination. Owner_id is overwritten from JWT for end users. All query fields are grouped in `listGoalsRequest`.
     *
     * @tags Goal
     * @name ListGoals
     * @summary List goals
     * @request GET:/goals
     * @secure
     */
    listGoals: (
      query?: {
        /** Owner user ID; defaults to JWT ospOwnerId. */
        owner_id?: string;
        /** Filter by one or more goal statuses. */
        status?: GoalStatusEnum[];
        /** When true, only goals with a valid diagnosis_content report (issues or plan). */
        has_diagnosis?: boolean;
        /** Filter by domain ring category. */
        category?: GoalCategoryEnum;
        /** Filter by checkup dimension codes. */
        dimension?: (
          | 101
          | 102
          | 103
          | 104
          | 105
          | 106
          | 107
          | 201
          | 202
          | 203
          | 301
          | 302
          | 303
          | 401
          | 402
          | 403
        )[];
        /**
         * Sort mode. CREATED = by created time desc (default).
         * PRIORITY = by dimension Engine priority (sort 1–16 ascending).
         */
        sort?: GoalSortEnum;
        /**
         * Page size (default 10, max 20).
         * @format int32
         * @min 1
         * @max 20
         * @default 10
         */
        limit?: number;
        /** Pagination cursor; omit for the first page. */
        next_token?: string;
        /**
         * When true, evaluates mixture onboarding required keys per goal dimension and
         * returns completeness.has_data=1 when all required data is present (may async-persist).
         * @default false
         */
        enrich_hash_data?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GoalPaginationResponse, any>({
        path: `/goals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a financial goal with metrics JSON and optional bound trackers. Idempotent on owner_id + request_id. Returns 201 with GoalDetailResponse. V2.8 status is required (typically INACTIVE for onboarding); INACTIVE create must not include tracker_specs.
     *
     * @tags Goal
     * @name CreateGoal
     * @summary Create goal
     * @request POST:/goals
     * @secure
     */
    createGoal: (data: CreateGoalRequest, params: RequestParams = {}) =>
      this.request<GoalDetailResponse, any>({
        path: `/goals`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns one goal by goal_id. Optionally embeds linked trackers when enrich_trackers=true.
     *
     * @tags Goal
     * @name GetGoal
     * @summary Get goal by id
     * @request GET:/goals/{id}
     * @secure
     */
    getGoal: (
      id: string,
      query?: {
        /**
         * When true, loads trackers with tracker.goal_id equal to this goal (ACTIVE, STOP, and COMPLETED only)
         * into Goal.trackers. Default false for a lighter response.
         * @default false
         */
        enrich_trackers?: boolean;
        /**
         * When true, evaluates mixture onboarding required keys for the goal dimension and
         * returns completeness.has_data=1 when all required data is present (may async-persist).
         * @default false
         */
        enrich_hash_data?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GoalDetailResponse, any>({
        path: `/goals/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates goal fields and/or replaces all goal-bound trackers. Only non-empty body fields are applied. Requires matching owner_id.
     *
     * @tags Goal
     * @name UpdateGoal
     * @summary Update goal
     * @request PUT:/goals/{id}
     * @secure
     */
    updateGoal: (
      id: string,
      data: UpdateGoalRequest,
      params: RequestParams = {},
    ) =>
      this.request<GoalDetailResponse, any>({
        path: `/goals/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  goalsStats = {
    /**
     * @description Returns first_created, activated_count, and activated_trackers_count for the authenticated owner. Owner is resolved from JWT ospOwnerId (no owner_id query parameter). Redis-cached 1d on server.
     *
     * @tags Goal
     * @name GetGoalStats
     * @summary Get goal statistics for current user
     * @request GET:/goals-stats
     * @secure
     */
    getGoalStats: (params: RequestParams = {}) =>
      this.request<GoalStatsResponse, any>({
        path: `/goals-stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  trackers = {
    /**
     * @description Create a proactive tracker and return the new tracker identifier.
     *
     * @tags Tracker
     * @name CreateTracker
     * @summary Create tracker
     * @request POST:/trackers
     * @secure
     */
    createTracker: (data: CreateTrackerRequest, params: RequestParams = {}) =>
      this.request<CreateTrackerResponse, any>({
        path: `/trackers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List trackers for an owner with cursor pagination. When sort_field and sort_order are omitted, the server defaults to created DESC.
     *
     * @tags Tracker
     * @name ListTrackers
     * @summary List trackers by owner
     * @request GET:/trackers
     * @secure
     */
    listTrackers: (
      query: {
        /**
         * Owner user ID
         * @minLength 1
         */
        owner_id: string;
        /**
         * Page size (max 100)
         * @format int32
         * @min 1
         * @max 100
         * @default 20
         */
        limit: number;
        /** Pagination token; omit for the first page */
        next_token?: string;
        /** When true, return only trackers with unread_count greater than 0 */
        unread_only?: boolean;
        /** Optional tracker lifecycle status filter. */
        statuses?: TrackerStatusEnum[];
        /** Optional tracker actor filter. */
        actors?: TrackerActorEnum[];
        /** Optional tracker display-type filter. */
        display_types?: string[];
        /** Include goal-bound tracker rows in the filtered result. */
        include_goal_trackers?: boolean;
        /** Sort field */
        sort_field?:
          | "created"
          | "last_triggered"
          | "next_triggered"
          | "triggers_count";
        /** Sort direction */
        sort_order?: "ASC" | "DESC";
      },
      params: RequestParams = {},
    ) =>
      this.request<TrackerPaginationResponse, any>({
        path: `/trackers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Return tracker detail including conditions.
     *
     * @tags Tracker
     * @name GetTracker
     * @summary Get tracker by id
     * @request GET:/trackers/{id}
     * @secure
     */
    getTracker: (id: string, params: RequestParams = {}) =>
      this.request<TrackerResponse, any>({
        path: `/trackers/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update tracker metadata (title, description, payload, condition_logic), status, conditions, or unread state. Pass unread_count=0 to mark as read. The body must include owner_id for authorization.
     *
     * @tags Tracker
     * @name UpdateTracker
     * @summary Update tracker
     * @request PATCH:/trackers/{id}
     * @secure
     */
    updateTracker: (
      id: string,
      data: UpdateTrackerRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/trackers/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Soft-delete a tracker. The body must include owner_id for authorization.
     *
     * @tags Tracker
     * @name DeleteTracker
     * @summary Delete tracker
     * @request DELETE:/trackers/{id}
     * @secure
     */
    deleteTracker: (
      id: string,
      data: DeleteTrackerRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/trackers/${id}`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List trigger and delivery records for a tracker with cursor pagination. For brief flow (id=0), rows may include brief-specific fields such as tracker_key and last_read_at (on first row only).
     *
     * @tags Tracker
     * @name ListTrackerRecords
     * @summary List tracker records by tracker id
     * @request GET:/trackers/{id}/records
     * @secure
     */
    listTrackerRecords: (
      id: string,
      query: {
        /**
         * Page size (max 100)
         * @format int32
         * @min 1
         * @max 100
         * @default 20
         */
        limit: number;
        /** Pagination token; omit for the first page */
        next_token?: string;
        /** Optional owner filter */
        owner_id?: string;
        /** Domain filter; for owner aggregate query when id=-1 */
        domain?: DomainEnum;
        /**
         * Start timestamp in epoch milliseconds; effective when id=-1
         * @format int64
         */
        start_time?: number;
        /**
         * Include tracker map for current page records
         * @default false
         */
        enrich_tracker?: boolean;
        /**
         * When true, return only records where read_at is null or missing
         * @default false
         */
        unread?: boolean;
        /** Brief feed mode; recommend = Brief recommend stream */
        query_type?: BriefQueryTypeEnum;
        /** Ad channel; present means ad-attribution session */
        query_channel?: BriefQueryChannelEnum;
        /** Interest category (one of 11 brief categories); present means interest-ad session */
        query_source?: string;
        /** Landing business identifier; when query_channel=THEME_RANK this is the OpenData theme slug (synced from backend openapi.yaml) */
        landing_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TrackerRecordPaginationResponse, any>({
        path: `/trackers/${id}/records`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Query schedule tracker occurrences in a UTC query window [start, end]. Completion state is resolved via tracker_record by occurrence_key. Each event includes goal_title when bound to a goal; there is no top-level goals array.
     *
     * @tags Tracker
     * @name ListScheduleCalendarEvents
     * @summary List schedule calendar events
     * @request GET:/trackers/schedule/calendar
     * @secure
     */
    listScheduleCalendarEvents: (
      query: {
        /**
         * Query window start inclusive (epoch milliseconds, UTC)
         * @format int64
         */
        start: number;
        /**
         * Query window end inclusive (epoch milliseconds, UTC)
         * @format int64
         */
        end: number;
        /** Filter by tracker domain (FINANCE / INVEST / OTHER) */
        domain?: DomainEnum;
        /** When set, filter trackers by whether last_triggered exists */
        has_triggered?: boolean;
        /** When true, return only trackers with unread_count greater than 0 */
        unread?: boolean;
        /** Same semantics as listTrackers include_goal_trackers */
        include_goal_trackers?: boolean;
        /**
         * Max events returned (default 500, max 2000)
         * @format int32
         * @min 1
         * @max 2000
         * @default 500
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ScheduleCalendarEventsResponse, any>({
        path: `/trackers/schedule/calendar`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  trackersDraft = {
    /**
     * @description Build tracker draft synchronously for a brief card.
     *
     * @tags Tracker
     * @name CreateTrackerDraft
     * @summary Create tracker draft from brief record
     * @request POST:/trackers-draft
     * @secure
     */
    createTrackerDraft: (
      data: CreateTrackerDraftRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateTrackerDraftResponse, any>({
        path: `/trackers-draft`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  records = {
    /**
     * @description Return a single tracker trigger or delivery record by record id.
     *
     * @tags Tracker
     * @name GetTrackerRecord
     * @summary Get tracker record by id
     * @request GET:/records/{id}
     * @secure
     */
    getTrackerRecord: (
      id: string,
      query?: {
        /** owner id */
        owner_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TrackerRecordResponse, any>({
        path: `/records/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update tracker record fields with idempotent semantics. Proactive brief records use mark-read flow; other records accept user_action_desc and read_at.
     *
     * @tags Tracker
     * @name UpdateTrackerRecord
     * @summary Mark tracker record as read
     * @request PATCH:/records/{id}
     * @secure
     */
    updateTrackerRecord: (
      id: string,
      data?: UpdateTrackerRecordRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTrackerRecordResponse, any>({
        path: `/records/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Direct owner-aggregated records query endpoint. Equivalent to GET /trackers/{id}/records when tracker id branch is -1. All query fields are grouped in `listRecordsRequest`. @type ListRecordsRequest
     *
     * @tags Tracker
     * @name ListRecords
     * @summary List owner tracker records
     * @request GET:/records
     * @secure
     */
    listRecords: (
      query: {
        /**
         * Page size (max 100)
         * @format int32
         * @min 1
         * @max 100
         * @default 20
         */
        limit: number;
        /** Pagination token; omit for the first page */
        next_token?: string;
        /** Optional owner filter */
        owner_id?: string;
        /** Domain filter for owner aggregate query */
        domain?: DomainEnum;
        /**
         * Start timestamp in epoch milliseconds for owner aggregate query
         * @format int64
         */
        start_time?: number;
        /**
         * Include tracker map for current page records
         * @default false
         */
        enrich_tracker?: boolean;
        /**
         * When true, return only records where read_at is null or missing
         * @default false
         */
        unread?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TrackerRecordPaginationResponse, any>({
        path: `/records`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a tracker record for user action completed flow (e.g. I've completed). Client supplies deterministic record_id; OpenSocial forwards to tracker service with event_type user_action; tracker latest fields are updated after record creation.
     *
     * @tags Tracker
     * @name CreateTrackerRecord
     * @summary Create user action tracker record
     * @request POST:/records
     * @secure
     */
    createTrackerRecord: (
      data: CreateUserActionRecordRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateTrackerRecordResponse, any>({
        path: `/records`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
